const zhCN = {
    login: {
        LOGIN_LOGIN: '登 录',
        RESET:'重 置',
        LOGIN_FGT_PWD: '忘记密码?',
        LOGIN_REGISTER: '注 册',
        LOGIN_ACCOUNT: '请输入用户名',
        PASSWORD: '请输入密码',
        TITLE: '用户登录',
        ACCOUNT:"账号",
        PASSWORD_PASSWORD:"密码",
        "欢迎使用OMS":"欢迎使用OMS",
        "账号密码":"账号密码",
        "验证码":"验证码",
        "账号手机号码":"账号/手机号",
        "密码":"密码",
        "手机号码":"手机号码",
        "获取验证码":"获取验证码",
        "登录/注册":"登录/注册",
        "若手机号码尚未注册将为您自动注册账户":"若手机号码尚未注册，将为您自动注册账户",
        "请输入手机号码":"请输入手机号码",
        "登录成功":"登录成功",
        "登录失败":"登录失败",
        "请填写正确的手机号码":"请填写正确的手机号码",
        "秒":"秒",
        "重置密码": "重置密码",
        "欢迎登陆":"欢迎登陆",
        "跨境V5":"跨境V5",
        "云平台":"云平台",
        "邮件验证码":"邮件验证码",
        "账号":"账号",
        "新密码":"新密码",
        "再次输入新密码":"再次输入新密码",
        "确定":"确定",
        "返回登录":"返回登录",
    },
    Main:{
        "网络连接中断！":"网络连接中断！",
        "系统版本有更新，点击确认加载最新，或按【CTRL + F5】！":"系统版本有更新，点击确认加载最新，或按【CTRL + F5】！ ",
        "系统提示":"系统提示 ",
        "您已打开过多的窗口，请关闭暂时不用的窗口后重新打开":'您已打开过多的窗口，请关闭暂时不用的窗口后重新打开',
        "未授权，请重新登录":"未授权，请重新登录",
        "错误请求":"错误请求",
        "拒绝访问":'拒绝访问',
        "请求错误，未找到该资源":"请求错误，未找到该资源",
        "请求方法为允许":"请求方法为允许",
        "请求超时":"请求超时",
        "服务器端出错":"服务器端出错",
        "网络未实现":'网络未实现',
        "网络错误":"网络错误",
        "服务不可用":"服务不可用",
        "网络超时":"网络超时",
        "http版本不支持该请求":'http版本不支持该请求',
        "网络连接超时，请稍候重试":"网络连接超时，请稍候重试",
        "网络中断，请检查网络是否正常":"网络中断，请检查网络是否正常",
        "连接错误":"连接错误",
    },
    templateEmployee: {
        employeeCode: '员工编号',
        employeeName: '员工姓名',
        enable: '是否启用',
        sex: '性别',
        statName: '所属网点',
        departmentName: '所属部门',
        position: '所在职位',
        positionCode: '岗位编号',
        status: '职位状态',
        workage: '工龄',
        dorm: '宿舍号',
        entrytime: '入职日期',
        leavetime: '离职日期',
        phone: '电话',
        createtime: '创建时间',
        creator: '创建人',
        modifytime: '修改时间',
        modifiyter: '修改人',
        contractDate: '合同截至日期',
        baseinfo: '基本信息',
        getGoodsDate: '领工衣日期',
        becomeOfficialDate: '转正日期',
        changeWorkDate: '调职日期',
        elphone: '电话',
        contactinfo: '联系信息',
        email: '邮箱',
        workplace: '工作地址',
        personinfo: '个人信息',
        birthday: '出生日期',
        mariage: '婚姻状况',
        mariaged: '已婚',
        unmariage: '未婚',
        speciality: '个人特长',
        compensation: '薪资等级',
        nations: '民族',
        education: '最高学历',
        major: '所学专业',
        identityCard: '身份证号',
        medicalCard: '社保号',
        bankCard: '银行账号',
        nativePlace: '籍贯',
        nowHomePlace: '现居住址',
        nativePlaceDetail: '家庭住址',
        homePhone: '家庭电话',
        emergencyContact: '紧急联系人',
        emergencyContactRelation: '联系人关系',
        emergencyContactPhone: '紧急联系电话',
        otherinfo: '其他信息',
        educationInfo: '教育经历',
        workExperience: '工作经历',
        workContent: '在职工作内容',
        workInfo: '在职工作情况',
        trainInfo: '在职培训情况',
        leaveReason: '工作调动原因'


    },
    custGroupSetting: {
        groupNo: '客户组编码',
        groupName: '客户组名称',
        isusing: '启用',
        isall: '所有分公司',
        statId: '适用分公司',
        remark: '备注',
        createDatetime: '建立时间',
        createUserName: '建立人',
        modifyDatetime: '修改时间',
        modifyUserName: '修改人'
    }
    ,
    menu_left:{
        "创建订单":"创建订单",
        "单票录入":"单票录入",
        "批量导入":"批量导入",
        "订单管理":"订单管理",
        "发货记录":"发货记录",
        "扫描打印":"扫描打印",
        "问题处理":"问题处理",
        "报价查询":"报价查询",
        "集运单管理":"集运单管理",
        "签收时效监控":"签收时效监控",
        "清关订单导入":"清关订单导入",
        FBA:'FBA',
        "我的余额":"我的余额",
        "账单管理":"账单管理",
        "账单明细":"账单明细",
        "升级B端客户":"升级B端客户",
    },
    menu: {
        home: '首页',
        OMSHOME:'OMS首页',
        configManage: '配置管理',
        tenantManage: '平台配置',
        organization: '组织',
        base: '基础',
        sortpartition:"分拣分区",
        strategy: '策略',
        JOB33:"取消小包管理",
        downloadorder:'平台下载订单',
        Order:'订单',
        TMS0129:"入库大包号导入",
        TMS0130:"退件登记",
        TMS124:"平台指定路线策略",
        TMS123:'接驳单管理',
        TMS125:'平台货物类型策略',
        TMS126:"报表分区",
        BIS026:"货态统计报表",
        BIS0261:"货态统计报表明细",
        TMS127:'货态比对策略',
        TMS127001:'货态比对策略导入',

        TMS128:'货态订阅方案',
        TMS133:'货态描述映射',
        cargoImport:'货态描述映射导入',
        BIS027:"货态比对报表",
        BIS0271:'货态比对报表明细',
        BIS028:"货态货量报表",
        BIS0281:'货态货量报表明细',
        BIS029:"客户干线监控报表",
        BIS0291:'客户干线监控报表明细',
        BIS030:'客户出货空运统计报表',
        BIS0301:'客户出货空运统计报表明细',
        BIS031:'签收时效监控报表',
        BIS0311:'签收时效监控报表明细',
        BIS032:'ShoppeAPI预报监控报表',
        BIS0321:'ShoppeAPI预报监控报表明细',
        BIS035:'客户签收时效报表',
        BIS0351:'客户签收时效报表明细',
        BIS036:'客户营业额报表',
        BIS0361:'客户营业额报表明细',
        BIS034:'WISH时效货量统计报表',
        BIS0341:'WISH时效货量统计报表明细',
        BIS033:'仓库库存报表',
        BIS037:'shoppe马来预报货量',
        KENG03:"分拣码导入",
        quantityDetail:"货量情况",
        BIS039:"时效监控报表",
        TMS0128:'清关订单导入',
        TMS129:"菜鸟无主件扫描",
        TMS0134:"抖音无主件扫描",
        TMS0135:'无主件处理',
        TMS013501:'无主件处理导入',
        BAS02522:'打印配置',
        TMS046:'参数设置',
        CMNOO1:'系统环境配置',
        BAS003:'网点管理',
        BAS004:'职位角色',
        BAS007:'选项设置',
        LOG001:'操作日志',
        BAS013:'客户管理',
        BAS016:'扫描状态',
        strategyorders:'订单',
        strategyoper:'操作',
        strategyagent:'代理',
        BAS043:'品名对照规则',
        BAS041:'运单分配规则',
        BAS062:'客户对接授权',
        BAS026:'代理EDI接口',
        BAS024:'转单分配规则',
        BAS064:'平台下载订单',
        Opeer:'操作',
        Return:'退件',
        Trunk:'干线',
        Problem:'异常',
        1:'港后',
        TMS:'港前',
        CustServ:'客服',
        QuoteCust:'客户',
        QuoteDelivery:'派送代理',
        QuoteTran:'承运代理',
        Quote5:'内部',
        Quote7:'清关信息设置',
        Quote6:'查价',
        BMS069:"应收整袋运费",
        BMS070:'应收代收手续费',
        SettlementRules:'结算规则',
        BMS090:'收入成本规则',
        CustomerSettlement:'应收结算',
        BMS030:'运单结算明细',
        // BMS807:'月度票数汇总',
        COD:'货款结算',
        feeReimburse:'费用报销',
        BIS:'报表',
        custType:'客户类',
        operation:'操作类',
        BIS014:'出货预报日报表',
        BIS010:'操作工作量日报表',
        shipType:'承运类',
        BISJIE:'结算类',
        BISMaoLi:'毛利类',
        BISSales:'销售类',
        BIS009:'公司毛利分析',
        CRM:'CRM',
        Monitor:'监控',

        BAS001:'首页设置',

        Authorization:'平台授权',
        downloadthelog:'下载日志',
        TMS094:'运单录入',
        TMS09402:'运单修改',
        TMS09403:'运单补录',
        TMS09401:'凡达',
        TMS101:'运单审单',
        JOB34:"取消大包管理",
        fdorderxuzw:'凡达录单-xuzw',
        OMS002:'单票录入',
        OMS0021:'单票修改',
        OMS0022:'单票浏览',
        OMS044:"签收时效监控报表",
        OMS0441:"签收时效监控报表明细",
        OMS045:'清关订单导入',
        TMS0921:'单票修改',
        TMS0922:'单票浏览',
        TMS091:'订单导入2',
        BAS002: '公司设置',
        BAS070:'轨迹推送配置',
        asyncOrderInput:'异常订单修改',
        BAS005: '员工管理',
        statManage: '网点管理',
        roleManage: '职位角色',
        BAS006: '授权管理',
        optionSetting: '选项设置',
        TMS061: '出货变更',
        TMS098:'派件',
        TMS099:'签收',
        SettIementl: '结算',
        SYS007: 'APP升级',
        SYS008: '导入设置',
        SYS006: '平台调用表配置',
        SYS005: '平台选项',
        SYS001: '一级模块设置',
        SYS002: '平台菜单设置',
        SYS003: '销售板块设置',
        SYS004: '平台职位角色',
        SYS098: '字典配置',
        tenantSetting: '租户设置',
        SettlementPayable: '应付结算',
        template: '标准模板',
        template1: '标准模板一',
        employee: '员工管理模板',
        userManage: '用户管理',
        userInfo: '用户资料',
        userData: '用户数据',
        deviceManage: '设备管理',
        statusManage: '状态监控',
        bill: '运单查询(暂停)',
        // TMS: '运单查询',
        menumag: '菜单管理',
        customerconnection:'客户对接授权',
        dockingset:'对接设置',
        transferanalysis:'转运分析',
        statmag: '网点管理',
        quote: '报价',
        BAS009: '指定路线',
        BAS010: '走货路线',
        destlimit: '目的地限制服务',
        BAS011: '排仓分区规则',
        BAS028: '客户分组',
        BAS022: '进位规则',
        BAS023: '计抛规则',
        BAS017: '问题状态',
        BAS018: '科目管理',
        BAS100: 'Shopee Service Code',
        BAS019: '汇率设置',
        BAS106: '申报汇率',
        BAS10601:"申报汇率导入",
        BAS020: '排货策略',
        BAS021: '分拣策略',
        BAS008: '目的地管理',
        BAS029: '账单公式',
        BAS030: '资金账户',
        BAS031: '收支科目',
        BAS035: '轨迹匹配设置',
        scanManage: '扫描状态',
        BAS072: '邮件推送设置',
        BAS073:'清关轨迹匹配规则',
        BAS060: '编码规则',
        BAS067: '分拣码',
        BAS101:'销售员提成设置',
        BAS102:'路线预估毛利',
        BAS10201:'路线预估毛利导入',
        BIS041:'公司预提数',
        BIS04101:'公司预提数明细',
        BAS10101:'销售员提成比例设置',
        BAS10102:'销售员提成设置导入',
        BIS040:'销售员提成报表',
        BIS04001:'销售员提成报表明细',
        TMS102:'取消小包',
        TMS103:'取消大包',
        MOA001:'spider轨迹对接监控',
        MOA003:'轨迹推送监控',
        MOA004: 'Kafka日志监控',
        MOA005:'平台对接监控',
        MOA007:'珊瑚COD推送监控',
        MOA008:'清关数据推送监控',
        MOA010:"异步下单监控",
        MOA011:"邮件推送监控",
        MOA012:'保险邮件推送',
        MOA013:'KEC ERP 监控',
        MOA014:'spider文件对接监控',
        MOA015:"安踏9610监控",
        custManage: '客户管理',
        waybilltomodify: '运单修改',
        TMS068:'运单自动追踪规则',
        changeaudit: '变更审核',
        BMS078: '应收客户运费2',
        BMS07801: '应收客户运费新增',
        BMS07802: '应收客户运费修改',
        BMS07803: '应收客户运费复制',
        BMS07804: '应收客户运费浏览',
        BMS001: '应收客户运费',
        BMS0011: '应收客户运费',
        BMS1011: '应收运费新增',
        BMS101: '应收运费新增',
        BMS102: '应收运费修改',
        BMS104: '应收运费复制',
        BMS103: '应收运费浏览',
        BMS002: '应收客户燃油',
        BMS012: '应收报价查询',
        BMS013: '应付报价查询',
        BMS003: '应收客户超值费',
        BMS010: '应付派送燃油',
        BMS011: '偏远查询',
        BMS009: '应付派送运费',
        quoteDestZone: '分区设置',
        BMS019: '客户费用导入',
        BMSAdd: '费用补录导入',
        BMSAddedFee: '增值费导入',
        BMSAddQuoteHubIm: '特殊报价导入',
        BMSAddQuoteHubCustIm: '关联客户导入',
        TMS0137:'现结客户报价',
        BAS066:'货物类型策略',
        BMSOawb:"承运账单明细导入",
        BMSAgeent:"派送费用导入",
        BMS059: '月末结转',
        BMS059001:'月末结转明细',
        BMS071: '承运费用分摊',
        BMS0711: '分摊明细',
        BMS0712: '分摊明细',
        BMS0713: '分摊明细',
        BMS085: '其他出纳',
        BMS081: '应付代收手续费',
        BMS109: '应付派送运费浏览',
        BMS110: '应付派送运费新增',
        BMS113: '应付派送运费复制',
        BMS111: '应付派送运费修改',
        BMS086: '应付派送其他',
        AuditBillDetails: '派送对账审核',
        AgentBillMaoLi: '对帐毛利分析',
        BMS0321: '派送费用录入',
        productcontrolrules:'品名对照规则',

        BAS065: '品名管理',
        BAS068: '在线充值规则',
        BAS069:'轨迹匹配规则',

        productnameimport:'品名对照导入',
        TMS0302:'清仓管理',
        TMS0301:'清仓明细',
        TMS0303:'清仓明细',
        TMS069:'来货上架',
        TMS070:'查货',
        TMS072:'收货上架',
        TMS078:'运单查询2',
        TMS121: '运单管理',
        TMS122: '已删除订单',
        TMS123001:'接驳单导入',
        speciallineremotedata:'专线偏远资料',
        test:'测试',
        TMS089:'入库预查',
        BMSWeig: '重量段设置',
        BMS076: '重量补差规则',
        TMS007: '排货',
        receivingbag:'收货装包',
        warehousing: '入库',
        output: '出库',
        TMS002: '收件录单',
        pcsauto: '单件称重',
        TMS028: '打单审核',
        TMS030: '清仓',
        TMS060: '条码打印',
        TMS003: '快速收货',
        TMS006: '运单查询',
        TMS095: 'Invoice查询',
        TMS09501: 'Invoice导入修改',
        TMS0061: 'Invoice明细',
        TMS004: '收货包管理',
        TMS00901: '装包扫描',
        TMS065: '上板',
        TMS06503: '拆板',
        TMS071: '班次交接',
        TMS077: '在途跟踪',
        TMS07101: '班次管理',
        TMS07102: 'COPY扫描',
        TMS07103: '总运单发送',
        TMS07104: '班次交接完成',
        TMS07105: '上板完成(关联班次)',
        TMS074: '班次轨迹追踪',
        TMS07401: '班次轨迹追踪明细',
        TMS010: '总运单管理',
        TMS120: '出货批次管理',
        MOA006:'outbound推送监控',
        MOA009:'Restart推送监控',
        outboundLogDtl:'推送明细数据',
        shipment2:'出货',
        shipment2details:'出货批次明细',
        TMS014: '港前问题件登记',
        TMS015: '港前问题件处理',
        TMS016: '港前问题件查询',
        problemsqueryprocessed: '已处理完毕港前问题件',
        TMS057: '港后问题件登记',
        TMS058: '港后问题件处理',
        TMS059: '港后问题件查询',
        CRM010:'港后问题件查询',
        TMS06701: '运单附件上传',
        TMS06702: '运单附件修改',
        TMS067: '运单附件管理',
        TMS079: '车辆管理',
        TMS080: '调度区域',
        TMS082: '取件申请',
        CRM007: '取件申请',
        TMS086: '交货上架',
        TMS088: '正常扫描',
        TMS084:'退件入库',
        TMS085:'退件出库',
        TMS083: '调度查询',
        TMS087: '交货查询',
        TMS081: '调度管理',
        TMS108: '港后问题件登记',
        TMS109: '港后问题件处理',
        TMS110: '港后问题件查询',
        TMS111: '代理问题件登记',
        TMS112: '代理问题件处理',
        TMS113: '代理问题件查询',
        TMS114:'清关路线',
        bounnemanagement: '退件入库管理',
        TMS017: '退返客户',
        TMS076: '运单修改',
        TMS018: '退件入库',
        TMS019: '运单轨迹追踪',
        TMS093: '面单套打',

        TMS096: '国内抵达',
        domesticarrivemanage:'抵达管理',
        TMS097: '进口到件',
        TMS100: '进口查询',

        trajectorytrackingimport: '批量导入轨迹',
        custlogimport: '导入客服日志',
        // ghwtjimport:'港后问题件批量导入',
        gqwtjimport:'港前问题件批量导入',
        ghwtjimport:'港后问题件批量导入',
        TMS020: '追踪查询',
        OMS005: '代理打单',
        POS003: '打单查询',
        frameHtml: 'HTML打印',
        printimport: '打单导入',
        printcustomizeimport: '打单自定义导入',
        BAS059: '自动转单规则',
        scanPrint: '扫描打印',
        POS011: '运单推送',
        OMS006: '打单审核',
        authorization: '平台授权',
        apiauth: 'API授权',
        OMS015: '扫描打印',
        OMS0181: '导入修改',
        OMS017: '取件申请',
        POS004: '转单分配规则',
        addTrackNoPool:'新增号码段（号码池）',
        trackNoPoolUsage:"单号使用情况",
        POS005: '运单分配规则',
        ediparameter: 'EDI字段参数',
		transferOrderConfig:'客户转单配置',
		customerFieldConfig:'客户字段配置',
        BMS031: '派送对账单导入',
        BAS012: '英文品名规则',
        POS025: '黑名单规则',
        BAS053: '寄件随机名单',
        randomrulesimport: '寄件随机名单导入',
        BAS050: '打单导入分解',
        BMS032: '派送账单明细',
        BMS075: '客户重量补差',
        BMS0751: '客户重量补差_1',
        BMS033: '派送对账单管理',
        BMS038: '代理账单管理',
        BMS0381: '代理账单管理明细',
        BMS0382: '承运账单明细数据',
        BMS807: '阶梯票数汇总',
        BMS8071: '统计明细数据',
        managewaybill: '总运单管理',
        sendwaybill: '总运单明细',
        applyfor: 'EDI申请情况',
        ediUse: 'EDI使用情况',
        waybilldetails: '总运单详情',
        agencyedi: '代理EDI接口',
        TMS009: '大包管理',
        upperboardmanagement: '上板管理',
        bagdetails: '大包明细',
        upperboarddetails: '板中详细',
        selectionwaybill: '选取运单',
        exporttemplatemanagement: '导出模板管理',
        exportset: '导出设置',
        BMS028: '出港路由',
        BMS020: '客户账单明细',
        BMS082: '客户解锁查询',
        BMS004: '包装费设置',
        BAS025: '打印配置',
        BAS027: '装包策略',
        BAS044: '上板策略',
        BAS071: '出货批次策略',
        BAS040: '单号验证规则',
        BMS007: '应收客户偏远费',
        BMS072: '收入成本规则',
        BMS073: '货款导入',
        BIS002: '指定路线毛利分析',
        BIS0021: '指定路线毛利分析明细',
        BIS012: '客户账龄报表',
        BIS013: '资金进出报表',
        BIS017: '客户走货报表',
        BIS018: '应收账龄分析表',
        BIS038: '应收账龄分析表',
        BIS03801: '应收账龄分析明细页面',
        BIS019: '超期账龄分析表',
        BIS020: '超期未收款统计',
        BIS0131: '资金进出报表明细',
        BIS007:'网点毛利',
        BIS024:'货量统计报表',
        BIS0241:"货量统计报表明细",
        BMS006: '应收客户包装费',
        BMS006001: '其他汇率',
        BAS014: '寄件人管理',
        BAS015: '公共收件人',
        BAS056: '货位管理',
        BMS092: '单票报价',
        BAS037: '代理管理',
        BAS045: '操作日志',
        BAS046: '参数设置',
        BAS055: '17单号规则',
        BAS058: '短信设置',
        TMS005: '运单录入',
        BalanceManage: '余额查询',
        BillChange: '账单变更',
        BillMag: '账单管理',
        BMS021: '客户账单管理',
        BMS024: '客户合并账单管理',
        BMS0241: '客户合并账单管理明细',
        BMS0211: '客户账单管理明细',
        BMS0212: '客户账单管理明细(包)',
        BMS022: '客户余额管理',
        BMS0221: '客户往来明细',
        BMS0222: '待审明细',
        BMS022001: "预扣费明细",
        notreceivebag: '未收货包',
        openorder: '未收货订单',
        waitwaybillsubmit: '待提交运单',
        bagreceive: '整袋收货',
        customerroutingrules: '客户打单规则',
        spiderTrajectoryDetail:'明细',
        BAS042: '重量采集设置',
        BMS008: '应收客户其他',
        BMS122: '应收客户增值费',
        BMS023: '客户账单明细(包)',
        BMS02301: '客户帐单明细(包)导入修改',
        BMS02302: '客户帐单明细(包)分摊明细',
        BMS025: '应付承运报价',
        BMS0251: '新增承运报价',
        BMS0252: '修改承运报价',
        BMS0253: '复制承运报价',
        BMS074: '销售成本报价',
        BMS077: '销售成本查询',
        BMS083: '内部取件成本',
        BMS0250: '应付承运商费用',
        BMS026: '内部成本报价',
        BMS037: '承运账单明细',
        BMS0371: '承运账单明细导入',
        BMS034: '代理余额管理',
        BMS035: '代理往来明细',
        BMS084: '费用补录管理',
        BMS094: '费用补录申请',
        BMS093: '代理费用补录管理',
        BMS098:'出口账单明细',
        BMS099:'进口账单明细',
        BMS095: '客户账单管理2',

        CMN004:'发件箱查询',
        CMN005:'报表导出',
        CMN006:"运单附件导出",
        BAS034: '运单追踪设置',
        BAS032: '目的地策略',
        BAS038: '干线追踪设置',
        BAS036: 'OMS授权',
        BAS057: '发件箱设置',
        Cashier: '出纳',
        CustCollect: '客户收款',
        BMS044: '客户收款登记',
        BMS096: '客户收款登记2',
        BMS097: '客户收款管理2',
        BMS0971: '客户收款浏览',
        BMS049: '资金帐户管理',
        BMS0491: '资金帐户往来明细',
        TMS024: '订单导入',
        CRM008: '订单导入',
        TMS090: '专线导入',
        OMS003: '订单导入',
        FBA:'FBA',
        OMSImport: '批量导入',
        OMS004: '订单列表',
        OMS018: '订单管理',
        OMS0041: '订单-单笔修改',
        OMS0042: '订单详情',
        OMS043:'集运单管理',
        TMS063: '运单导入修改',
        BMS060: '客户收款管理',
        accounttransfer:'账户转账',
        waybillsettlement:'运单结算明细',
        reimbursement:'费用报销管理',
        reimbursementr:'费用报销登记',
        operatingworkload:'操作工作量日报表',
        operatingworkloaddetail:'操作工作量明细',
        shipmentreport:'出货预报日报表',
        shipmentreportdetail:'出货预报日报表明细',
        BMS06001: '客户收款修改',
        BMS06002: '应收账单确认',
        BMS06003: '应收账单确认(包单)',
        BMS06006: '客户收款浏览',
        BMS061: '客户现金缴款',
        BMS062: '客户收款审核',
        BMS06201: '收款审核',
        BMS063: '客户核销管理',
        BMS06301: '账单核销明细',
        BMS06302: '帐单确认异常明细',
        BMS040: '代理付款',
        BMS041: '内部转账',
        BMS042: '其他调账',
        BMS043: '核销管理',
        BMS048: '账户余额管理',
        BMS045: '代理付款申请',
        BMS064: '代理付款管理',
        BMS0641: '代理付款修改',
        BMS0642: '代理付款浏览',
        BMS065: '代理付款审核',
        BMS066: '代理付款',
        BMS0661: '代理付款审核确认',
        BMS0651: '代理付款审核确认',
        BMS067: '代理核销管理',
        BMS0671: '账单核销详情',
        CRM012: '单票录入',
        CRM018: '销售员杂费报价',
        CMN10010:"自提点查询",
        CRM017: '销售员提成设置',
        CRM016: '销售员底薪设置',
        CRM014: '客户报价单',
        CRM013: '订单导入2',
        //货款
        BMS014: '货款回款',
        BMS015: '回款对账单导入',
        BMS0151: '回款对账单审核',
        BMS016: '回款对账单管理',
        BMS017: '货款回款账单',
        BMS0171: '货款回款账单明细',
        BMS0172: '查看回款水单',
        BMS018: '货款返款',
        BMS068: '货款返款账单',
        BMS0681: '货款返款帐单明细',
        BMS0682: '查看返款水单',
        orderedi:'订单EDI',
        ediopen:'EDI开通',
        BAS061:'LABEL设计',
        BAS063:'订单下载日志',
        cargotypestrategy:'货物类型策略',
        designatedroutestrategy:'指定路线规则',

        BMS046: '费用报销',
        BMS047: '报销付款',
        BMS079: '账户转账',
        BMS080: '出纳明细',
        BMS091: '销售员成本查询',
        BIS015: '客户往来报表',
        BIS0151: '客户往来报表明细',

        BIS011: '客户对帐报表',
        transshipment:'转运',
        TMS012:'转运发件',
        TMS0126:"ICBU中心仓工单",
        TMS134:'菜鸟Tracepush',
        TMS135:'SLA复核',
        TMS136:'Shopee节点推送',
        TMS0121:'转运发件管理',
        TMS0122:'转运发送',
        TMS0123:'转运单明细',
        TMS0124:'转运分析',
        TMS013:'转运到件',
        TMS0131:'转运到件管理',
        TMS0132:'转运到达',
        TMS0133:'转运单明细',
        TMS032:'干线轨迹追踪',
        TMS062:'变更审核',
        TMS0621:'运单修改',
        TMS00102:'预报修改',
        TMS00103:'导入修改',
        TMS073:'专线录单',
        TMS075:'单证预查',
        OMS0071:'运单详情',
        TMS001:'订单预报',
        TMS092:'单票录入',
        orderinput:'单票录入',
        TMS00101:'shopeeApi预报',
        quotehubbagging:'应收整包运费',
        quotecommission:'应收代收手续费',
        quotecommission001:'应收代收手续费导入',
        inspection:'查货',
        BMS120: '应收专线偏远费',
        BMS121: '专线偏远费查询',
        importspecialcost: '专线偏远导入',
        // OMS008:'问题件',
        OMS008:'问题处理',
        OMS0081:'问题件回复',
        trackquery:'轨迹查询',
        OMS007:'发货记录',
        gxgjglimport:'导入轨迹',
        zydglimport:'补录导入',
        zydzdimport:'子运单箱号关系导入',
        orderPrint:'代理打单',
        agenttoplaysingle:'代理打单',
        agenttoplaysingleadvance:'预打单',
        deliveryrecord:'发货记录',
        OMS009:'报价查询',
        OMS012:'账单管理',
        OMS016:'账单明细',
        OMS0121:'账单明细',
        OMS0122:'账单明细（包）',
        OMS010:'偏远查询',
        OMS011:'我的余额',
        OMS0111:'待审明细',
        //BIS
        BIS001:'客户发货日报表',
        BIS0011:'当日预报明细',
        BIS0012:'历史收件明细',
        BIS0013:'当日收件明细',
        BIS003:'仓库操作日报表',
        BIS0031:'仓库操作明细',
        BIS005:'干线运输时效报表',
        BIS023:'代理往来报表',
        BIS0231:'代理往来明细',
        BIS004:'收入成本源报表',
        companyanalysis:'公司毛利分析',
        companyanalysisdetail:'公司毛利分析明细',
        BIS006:'总运单毛利分析',
        BIS0061:'总运单毛利分析明细',
        BIS008:'网点毛利',
        BIS0081:'网点运营毛利明细',
        BIS0082:'网点销售毛利明细',
        BIS016:'销售客户数报表',
        BIS0161:'销售客户数报表明细',

        BIS021:'寄件人发货月报表',
        BIS0211:'预报明细',
        BIS0212:'收件明细',
        BIS022:'销售员毛利统计',
        BIS0221:'销售员毛利统计明细',
        
        TMS130:'集运客户管理',
        Consolidation:"集运",
        TMS131:"集运单管理",
        TMS132:'集运单退货',
        TMS137:'集运单普敏转换',
        TMS138:'拼多多拒签',
        TMS139:'拼多多无主件扫描',
        CMN001:'系统环境配置',
        CMN002:'消息',
        CMN003:'短信',
        shortmessageimport:'短信导入',
        BMS123:'批价任务',
        BMS1231:'任务详情',
        BMS124:'派送批价任务',
        BMS1241:'派送批价任务详情',
        CRM001:'客户视图',
        CRM002:'运单视图',
        CRM003:'销售员设置',
        CRM004:'销售员统计报表',
        CRM0041:'销售员统计报表明细',
        CRM005: '港前问题件查询',
        CRM006: '港后2问题件查询',
        CRM009: '订单预报',
        CRM0091: '单票修改',
        CRM011: '单票报价',
        BMS100: '销售员成本单票报价',
        CRM015: '销售员额度管理',
        pulldownBagging:'拆包',
        CRM015001:"销售员解锁记录查询",
        CMN150: "报表定时导出",
        OMS050: "升级B端客户",
        BAS103: "审批列表",
        OMS022001: "预扣费明细",
        TMS050: "销售确认",
        TMS051: "产品确认",
    },
    hint: {
        switchLanguageSuccess: "切换语言成功",
        orderNumberInputTip: "订单号码下拉选择想要查询的号码,多个号码可以分行输入查询",
        billNumberInputTip: "账单号码下拉选择想要查询的号码，多个号码可以分行输入查询",
        invoiceImportStep1: "第一步：下载INVOICE导入Excel模板",
        invoiceImportStep2: "第二步：上传INVOICE导入Excel模板",
        importStep1: "第一步：下载导入Excel模板",
        importStep2: "第二步：上传导入填写好的Excel模板",
        generateCodeTip: "选填，选择客户即生成绑定此客户的邀请码。用户账号使用此邀请码则自动建立与此客户的对应绑定关系。不选择客户即生成正常邀请码。",
        dissolveTipInfo: "你确定需要进行这个操作，来解除和对方的合作关系吗？",
        agreementTip: "同意《哲盟网络服务条例》|《法律声明及隐私权政策条例》",
        exitTrue: '是否确定退出控制中心'
    },
    common: {
        total: "总共",
        records: "记录数",
        Order_002: "订单编号",
        Order_004: "运单号码",
        Order_005: "转单号码",
        ORDERS_05: "参考编号",
        transChannel: "运输渠道",
        destination: "目的地",
        country: "国家/地区",
        city: "城市",
        state: "州/省",
        remark: "备注",
        weight: "重量",
        currency: "币别",
        phoneNum: "手机号码",
        name: "姓名",
        gender: '性別',
        men: "男",
        women: "女",
        tip: "提示",
        onjob: '在职',
        dimission: '离职',
        enable: '启用'

    },
    formOperation: {
        search: '查询',
        reset: '重置',
        preview: "预览",
        save: "保存",
        cancel: "取消",
        del: '删除',
        confirm: "确定",
        submit: "提交",
        saveEdit: "保存修改",
        backList: "返回列表",
        batchExport: "批量导出",
        allExport: "全部导出",
        export: '导出',
        batchImport: "批量导入",
        invoiceImport: "INVOICE导入",
        batchExamine: "批量审核",
        batchPrint: "批量打印",
        downExcelTemplate: "下载Excel模板",
        uploadExcel: "上传Excel",
        uploadExcelTemplate: "上传Excel模板",
        edit: '修改',
        insert: '新增',
        close: '关闭'

    },
    tableSimple: {
        bas_whether_type: {
            1: '是',
            0: '否'
        },
        bas_isusing_type: {
            1: '启用',
            0: '停用'
        },
        bas_destzone_type: {
            1: '应收分区',
            2: '应付分区'
        },
        bas_scan_type: {
            1: '正常扫描',
            2: '签收扫描',
            3: '板号扫描',
            4: '包号扫描',
            5: '其他扫描'
        },
        bas_stat_type: {
            1: '总部',
            2: '分拨中心',
            7: '代理',
            6: '承运商',
            8: '收派网点'
        },
        bas_standard_cur: {
            CNY: '人民币',
            HKD: '港币',
            USD: '美元',
            EUR: '欧元'
        },
        bas_fit_type: {
            1: '适用单件/单票',
            2: '适用单件',
            3: '适用单票'
        },
        bas_arded_type: {
            1: '应收科目',
            2: '应付科目',
            3: '计算科目'
        },
        bas_work_type: {
            1: '客户科目',
            2: '代理科目',
            3: '承运科目',
            4: '内部科目',
            5: '其它科目'
        },
        bas_express_type: {
            1: '国际快件',
            2: '国内快件'
        },
        bas_problem_type: {
            1: '收获问题件',
            2: '打单问题件',
            3: '查验问题件',
            4: '代理追踪',
            5: '港后跟踪',
        },
        bas_use_status: {
            1: '待使用',
            2: '使用中',
            3: '已停用'
        },
        bas_cust_status_type: {
            1: '启用',
            2: '停用',
            3: '暂停'
        },
        bas_cust_type: {
            1: '内部结算客户',
            2: '派送代理',
            3: '欠款客户',
            4: '日结赊销客户',
            5: '现结客户',
            6: '预付控制客户',
            10: '月结赊销客户',
            8: '周结赊销客户',
            9: '月结客户',
            7: '票结客户',
            11: '自打单客户',
            12: '永久黑名单客户',
            13: 'D类客户',
            14: '周结客户'
        },
        bas_button_type: {
            1: '新增',
            2: '修改',
            3: '删除',
            4: '导出',
            5: '浏览',
            6: '审核',
            7: '撤销审核',
            8: '启用',
            9: '停用',
            10: '其他'
        },
        bas_language_type: {
            CN: '简体',
            EN: '英文'
        },
        bas_role_type: {
            1: '平台管理员',
            2: '租户管理员',
            3: '普通用户'
        },
        bas_cust_group_type: {
            1: '应收客户组',
            2: '应付客户组',
            3: '公用客户组'
        },
        bas_hubin_type: { //指定线路分类
            1: 'DHL-HK',
            2: 'DHL-CN',
            3: 'DHL-MO'
        },
        bas_hubout_type: {
            501: '港台',
            502: '澳门',
            503: '深圳'
        },
        bas_cocustom_type: {
            1: 'D类',
            2: '其它'
        },
        bas_dest_limit_type: {
            701: '测试1',
            702: '测试2',
            703: '测试3'
        },
        bas_good_type: {//限定货物类型
            DC: '电池',
            SJ: '手机',
            PH: '普货',
            PI966: 'PI966',
            PI970: 'PI970',
            PI968: 'PI968',
            'PI967-2:': 'PI967-2',
            'SP A123': 'SP A123'
        },
        // bas_cocustom_type: {//报关方式
        //     DL: 'D类',
        //     EDI: 'EDI',
        //     KJ: '快件',
        //     QT: '其它',
        //     DDBG: '单独报关'
        // },
        bas_sorting_port: {//分拣卡口
            '01': '01',
            '02': '02',
            '03': '03',
            '04': '04',
            '05': '05',
            '06': '06',
            '07': '07',
            '08': '08',
            '09': '09',
            '10': '10',
            '11': '11',
            '12': '12',
            '13': '13',
            '14': '14'
        },
        //共享方式
        bas_share_type: {
            1: '不共享',
            2: '共享给所有',
            3: '共享给指定'
        }
        , bas_post_status: {
            0: '离职',
            1: '在职'
        }
        , bas_sex: {
            1: '男',
            2: '女',
        }
        , bas_business_type: {
            301: '快递业务',
            302: '海运业务',
            303: '空运业务',
            304: '邮政小包',
            305: '海外仓'
        },
        bas_quote_type: {
            0: '首重续重',
            1: '直接价格'
        }
        , bas_packing: {
            DOC: '文件',
            PAK: '胶包',
            WPX: '包裹'
        },
        bas_postal_type: {
            201: 'DHL',
            202: 'UPX',
            203: 'FEDEX',
            204: 'TNT',
        },
        bas_pay_type: {
            CC: '到付',
            PP: '寄付',
            TP: '第三方付款',
        },
        //排货状态
        tms_inventory_state: {
            0: '待排货',
            1: '已排货'
        },
        //排货方式
        tms_inventory_type: {
            1: '自动排货',
            2: '人工排货'
        },
        //排货策略
        tms_inventory_mode: {
            1: '唯一走货路线',
            2: '价格最优路线',
            3: '重量最优路线',
            4: '无有效价格',
            5: '无走货路线'
        },
        //计费方式
        bas_fee_Type: {
            1: '按件',
            2: '按票'
        },
        bas_additional_fee: {
            1: '不收项目',
            2: '附加手续服务',
            3: '超过最大限制附加费'
        },
        //结算对象
        bas_object_type: {
            0: '客户',
            1: '代理',
            2: '承运商',
            3: '内部'
        },
        //收付方向
        bas_transaction_type: {
            0: '应收',
            1: '应付'
        },
        //账单号码规则
        bas_formula_coderule: {
            0: '网点编码',
            1: '公式编码',
            2: '流水号三位',
            3: '流水号四位',
            4: '流水号五位',
            5: '日两位',
            6: '月二位',
            7: '年两位',
            8: '年四位'
        },
        //运单状态
        bas_manifest_status: {
            1: '待收货',
            2: '已收货',
            3: '已出货'
        },
        //导入状态
        bas_import_state: {
            1: '验证中',
            2: '验证通过',
            3: '验证失败',
            4: '导入中',
            5: '成功',
            6: '失败'
        }

    },
    "page":{
        "SYS001":{
            "你好":"你{0}好{1}",
            "内容有修改":"内容有修改，是否确认关闭？",
            "修改":"修改",
            "保存并继续":"保存并继续",
            "修改成功":"修改成功",
            "查询":"查询",
            "保存":"保存",
            "模块信息":"模块信息",
            "添加成功":"添加成功",
            "模块编码":"模块编码",
            "创建人":"创建人",
            "修改异常":"修改异常",
            "模块编码必须为三位大写字母":"模块编码必须为三位大写字母",
            "删除异常":"删除异常",
            "修改人":"修改人",
            "获取模块列表异常":"获取模块列表异常",
            "确定要删除吗":"确定要删除吗",
            "删除成功":"删除成功",
            "模块名称":"模块名称",
            "删除":"删除",
            "关闭":"关闭",
            "重置":"重置",
            "启用":"启用",
            "模块应用场景":"模块应用场景",
            "新增模块":"新增模块",
            "修改时间":"修改时间",
            "请选择一行数据":"请选择一行数据",
            "一级模块":"一级模块",
            "新增":"新增",
            "模块功能说明":"模块功能说明",
            "确定":"确定",
            "提示":"提示",
            "导出":"导出",
            "请输入":"请输入",
            "取消":"取消",
            "创建时间":"创建时间",
            "不能为空":"不能为空",
            "添加异常":"添加异常",
            "修改模块":"修改模块",
        }
    },
    "pages":{
        "bas":{
            "sorting":{
                "sorting":{
                    "修改":"修改",
                    "分拣码信息":"分拣码信息",
                    "优先级":"优先级",
                    "分拣码":"分拣码",
                    "名称":"名称",
                    "走货路线":"走货路线",
                    "分拣规则":"分拣规则",
                    "指定路线":"指定路线",
                    "客户":"客户",
                    "保存":"保存",
                    "关闭":"关闭",
                    "启用":'启用',
                    "国家简码":"国家简码",
                    "货物类型":"货物类型",
                    "分拣分区":"分拣分区",
                    "报关方式":"报关方式",
                    "收费重范围":"收费重范围",
                    "申报价值范围":"申报价值范围",
                    "COD金额范围":"COD金额范围",
                    "拦截":"拦截",
                },
            },
            "zipdestinationstrategy":{
                "zipdestinationstrategy":{
                    "增加":"增加",
                    "修改":"修改",
                    "删除":"删除",
                    "新增":"新增",
                    "导出":"导出",
                    "目的地策略":"目的地策略",
                    "邮编分类":"邮编分类",
                    "国家简码":"国家简码",
                    "邮编":"邮编",
                    "目的地":"目的地",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "邮编目的地策略":"邮编目的地策略",
                    "启用":"启用",
                    "国家":"国家",
                    "邮编目的地分类":"邮编目的地分类",
                    "起始邮编":"起始邮编",
                    "终止邮编":"终止邮编",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "分类编码":"分类编码",
                    "分类名称":"分类名称",
                    "排列顺序":"排列顺序",
                    "新增邮编目的地策略":"新增邮编目的地策略",
                    "新增邮编目的地分类":"新增邮编目的地分类",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请输入":"请输入",
                    "是否删除当前邮编目的地分类?":"是否删除当前邮编目的地分类?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功！":"删除成功！",
                    "请选择一行数据":"请选择一行数据",
                    "是否删除该邮编目的地策略":"是否删除该邮编目的地策略",
                    "删除异常":"删除异常",
                    "起始邮编只允许填入数值、大写字母":"起始邮编只允许填入数值、大写字母",
                    "终止邮编只允许填入数值、大写字母":"终止邮编只允许填入数值、大写字母",
                    "终止邮编长度必须与起始邮编长度一致":"终止邮编长度必须与起始邮编长度一致",
                    "添加异常":"添加异常",
                    "添加成功！":"添加成功！",
                    "修改异常":"修改异常",
                    "修改成功！":"修改成功！",
                    "修改邮编目的地策略":"修改邮编目的地策略",
                    "修改邮编目的地分类":"修改邮编目的地分类",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                }
            },
            "productcontrolrules":{
                "productcontrolrules":{
                    "导入":"导入",
                    "删除":"删除",
                    "导出":"导出",
                    "品名对照规则":"品名对照规则",
                    "英文品名":"英文品名",
                    "中文品名":"中文品名",
                    "查询":"查询",
                    "重置":"重置",
                    "备注":"备注",
                    "创建人":"创建人",
                    "创建时间":"创建时间",
                    "修改人":"修改人",
                    "修改时间":"修改时间",
                    "确定要删除吗？":"确定要删除吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择一行数据":"请选择一行数据",
                    "删除异常":"删除异常",
                    "删除成功！":"删除成功！",
                    "接口对接INVOICE时如中文品名为空，需自动根据英文品名转换为中文品名":"接口对接INVOICE时如中文品名为空，需自动根据英文品名转换为中文品名",
                    "匹配英文品名，得到中文品名;被选中的记录需符合以下条件，以分号分隔的字符串需包含在INVOICE的英文品名中（不分先后顺序），优先于完全匹配":"匹配英文品名，得到中文品名;被选中的记录需符合以下条件，以分号分隔的字符串需包含在INVOICE的英文品名中（不分先后顺序），优先于完全匹配",
                },
                "productnameimport":{
                    "导入模版":"导入模版",
                    "模版下载":"模版下载",
                    "导入":"导入",
                    "批次号":"批次号",
                    "导入文件":"导入文件",
                    "导入时间":"导入时间",
                    "状态":"状态",
                    "总行数":"总行数",
                    "错误行数":"错误行数",
                    "文件下载":"文件下载",
                    "历史日志":"历史日志",
                    "导入历史日志":"导入历史日志",
                    "请输入":"请输入",
                    "行号":"行号",
                    "英文品名":"英文品名",
                    "错误说明":"错误说明",
                    "请选择模版！":"请选择模版！",
                    "请选择导入模版！":"请选择导入模版！",
                    "导入文件不能超过10MB":"导入文件不能超过10MB",
                    "解析中":"解析中",
                    "失败":"失败",
                    "导入中":"导入中",
                    "上传中":"上传中",
                    "上传失败":"上传失败",
                    "解析失败":"解析失败",
                    "验证中":"验证中",
                    "验证失败":"验证失败",
                    "成功":"成功",
                    "订单导入成功":"订单导入成功",
                    "导入成功才可下载":"导入成功才可下载",
                },
            },
            "descrmanage":{
                "descrmanage":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "品名信息":"品名信息",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "海关编码":"海关编码",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "税率":"税率",
                    "品牌":"品牌",
                    "材质":"材质",
                    "用途":"用途",
                    "规格":"规格",
                    "备注":"备注",
                    "保存":"保存",
                    "关闭":"关闭",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请输入":"请输入",
                    "新增品名":"新增品名",
                    "修改品名":"修改品名",
                    "请选择品名":"请选择品名",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除该品名, 是否继续?":"此操作将删除该品名, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                }
            },
            "customerconnection":{
                "customerconnection":{
                    "启用订单":"启用订单",
                    "保存并继续":"保存并继续",
                    "在收货时会根据实际收货的重量与材积验证排货准确性":"在收货时会根据实际收货的重量与材积验证排货准确性",
                    "新增客户对接授权":"新增客户对接授权",
                    "全部":"全部",
                    "按关键字检索":"按关键字检索",
                    "打单指定路线":"打单指定路线",
                    "指定路线":"指定路线",
                    "保存":"保存",
                    "排货走货路线":"排货走货路线",
                    "密钥":"密钥",
                    "请选择客户":"请选择客户",
                    "已启用订单授权":"已启用订单授权",
                    "已选客户列表":"已选客户列表",
                    "订单授权开放指定路线":"订单授权开放指定路线",
                    "已启用授权":"已启用授权",
                    "固定走货路线":"固定走货路线",
                    "打单授权操作":"打单授权操作",
                    "会自动产生问题件":"会自动产生问题件",
                    "注意":"注意",
                    "帐户":"帐户",
                    "打印前置使用":"打印前置使用",
                    "所属网点":"所属网点",
                    "已启用打单授权":"已启用打单授权",
                    "未启用授权":"未启用授权",
                    "订单授权操作":"订单授权操作",
                    "客户名称":"客户名称",
                    "新增授权":"新增授权",
                    "启用订单授权":"启用订单授权",
                    "打单重量小于收费重":"打单重量小于收费重",
                    "启用打单授权":"启用打单授权",
                    "停用":"停用",
                    "授权成功！":"授权成功！",
                    "走货路线":"走货路线",
                    "启用订单授权与启用打单授权必勾其一":"启用订单授权与启用打单授权必勾其一",
                    "停用授权":"停用授权",
                    "由系统按排货策略选取走货路线后再打单":"由系统按排货策略选取走货路线后再打单",
                    "打单走货路线规则":"打单走货路线规则",
                    "关闭":"关闭",
                    "订单授权":"订单授权",
                    "启用":"启用",
                    "收货时验证排货":"收货时验证排货",
                    "打单成功！":"打单成功！",
                    "客户":"客户",
                    "当打单走货路线规则":"当打单走货路线规则",
                    "可设置走货路线":"可设置走货路线",
                    "客户列表":"客户列表",
                    "停用打单":"停用打单",
                    "客户接口授权":"客户接口授权",
                    "客户编码":"客户编码",
                    "启用客户":"启用客户",
                    "对接设置":"对接设置",
                    "勾选后":"勾选后",
                    "打单授权":"打单授权",
                    "停用订单":"停用订单",
                    "启用打单":"启用打单",
                    "时且勾选收货时验证排货":"时且勾选收货时验证排货",
                    "订单成功！":"订单成功！",
                    "时":"时",
                    "排货前置和":"排货前置和",
                    "待选指定路线":"待选指定路线",
                    "此设置用于":"此设置用于",
                    "表示客户对应指定路线按走货路线成本价格进行结算":"表示客户对应指定路线按走货路线成本价格进行结算",
                    "客户编码/客户名称":"客户编码/客户名称"
                },
                "dockingset":{
                    "回调地址":"回调地址",
                    "关闭":"关闭",
                    "保存对接设置成功":"保存对接设置成功",
                    "请输入":"请输入",
                    "注册":"注册",
                    "API名称":"API名称",
                    "保存对接设置异常":"保存对接设置异常",
                    "对接设置":"对接设置",
                    "备注":"备注",
                    "接口参数 <":"接口参数 <",
                    "生成回调地址":"生成回调地址",
                    "API编码":"API编码"
                }
            },
            "tracknorule":{
                "trackNoRule":{
                    "修改":"修改",
                    "示例单号":"示例单号",
                    "规则":"规则",
                    "可用份数":"可用份数",
                    "规则名称":"规则名称",
                    "起始单号不符合单号规则":"起始单号不符合单号规则",
                    "删除":"删除",
                    "指定路线":"指定路线",
                    "查询":"查询",
                    "关闭":"关闭",
                    "保存":"保存",
                    "重置":"重置",
                    "启用":"启用",
                    "请生成":"请生成",
                    "修改时间":"修改时间",
                    "可多选":"可多选",
                    "请选择一行数据":"请选择一行数据",
                    "创建人":"创建人",
                    "预警份数":"预警份数",
                    "修改异常":"修改异常",
                    "起始单号":"起始单号",
                    "请先输入单号规则":"请先输入单号规则",
                    "新增17单号规则":"新增17单号规则",
                    "新增":"新增",
                    "确定":"确定",
                    "规则编码":"规则编码",
                    "终止单号":"终止单号",
                    "请先输入起始单号或终止单号":"请先输入起始单号或终止单号",
                    "提示":"提示",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "删除成功！":"删除成功！",
                    "启用状态":"启用状态",
                    "修改17单号规则":"修改17单号规则",
                    "删除异常":"删除异常",
                    "添加成功！":"添加成功！",
                    "确定删除吗？":"确定删除吗？",
                    "请输入":"请输入",
                    "正在使用中，请谨慎操作。确定删除吗？":"正在使用中，请谨慎操作。确定删除吗？",
                    "修改人":"修改人",
                    "取消":"取消",
                    "创建时间":"创建时间",
                    "单号规则":"单号规则",
                    "终止单号不符合单号规则":"终止单号不符合单号规则",
                    "添加异常":"添加异常",
                    "生成示例单号":"生成示例单号",
                    "总份数":"总份数",
                    "修改成功！":"修改成功！"
                }
            },
            "inventorystrategy":{
                "inventorystrategy":{
                    "排货策略":"排货策略",
                    "修改":"修改",
                    "如":"如",
                    "保存并继续":"保存并继续",
                    "英文目的地":"英文目的地",
                    "终止邮编":"终止邮编",
                    "收件邮编格式":"收件邮编格式",
                    "修改成功":"修改成功",
                    "名称":"名称",
                    "指定路线启用":"指定路线启用",
                    "指定路线":"指定路线",
                    "查询":"查询",
                    "选择":"选择",
                    "保存":"保存",
                    "邮编只能包含数字、逗号和“-”":"邮编只能包含数字、逗号和“-”",
                    "调用表配置加载失败，请联系管理员！":"调用表配置加载失败，请联系管理员！",
                    "收件邮编":"收件邮编",
                    "创建人":"创建人",
                    "指定路线比价排货":"指定路线比价排货",
                    "多组用回车或逗号隔开":"多组用回车或逗号隔开",
                    "限制货物类型":"限制货物类型",
                    "请选择排货策略":"请选择排货策略",
                    "请选择数据":"请选择数据",
                    "多选":"多选",
                    "新增排货策略":"新增排货策略",
                    "编码":"编码",
                    "此操作将删除该排货策略, 是否继续?":"此操作将删除该排货策略, 是否继续?",
                    "请选择":"请选择",
                    "修改排货策略":"修改排货策略",
                    "选择客户":"选择客户",
                    "所属网点":"所属网点",
                    "修改人":"修改人",
                    "不含目的地服务限制中的货物类型":"不含目的地服务限制中的货物类型",
                    "客户名称":"客户名称",
                    "序号":"序号",
                    "删除成功":"删除成功",
                    "走货路线":"走货路线",
                    "删除":"删除",
                    "关闭":"关闭",
                    "重置":"重置",
                    "刷新":"刷新",
                    "简体目的地":"简体目的地",
                    "目的地":"目的地",
                    "修改时间":"修改时间",
                    "目的地和邮编只能填写其一":"目的地和邮编只能填写其一",
                    "单选":"单选",
                    "新增":"新增",
                    "确定":"确定",
                    "目的地编码":"目的地编码",
                    "提示":"提示",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "客户编码":"客户编码",
                    "起始邮编":"起始邮编",
                    "起始与终止长度一致":"起始与终止长度一致",
                    "新增成功":"新增成功",
                    "限定货物类型":"限定货物类型",
                    "导出":"导出",
                    "取消":"取消",
                    "创建时间":"创建时间",
                    "选取":"选取"
                }
            },
            "sortingstrategy":{
                "sortingstrategy":{
                    "请选择分拣策略":"请选择分拣策略",
                    "修改":"修改",
                    "保存并继续":"保存并继续",
                    "英文目的地":"英文目的地",
                    "分拣码":"分拣码",
                    "新增分拣策略":"新增分拣策略",
                    "请输入分拣卡口或分拣码！":"请输入分拣卡口或分拣码！",
                    "报关类型":"报关类型",
                    "删除成功":"删除成功",
                    "修改成功":"修改成功",
                    "走货路线":"走货路线",
                    "请输入目的地、报关方式或货物类型！":"请输入目的地、报关方式或货物类型！",
                    "删除":"删除",
                    "请输入客户或走货路线！":"请输入客户或走货路线！",
                    "查询":"查询",
                    "关闭":"关闭",
                    "保存":"保存",
                    "重置":"重置",
                    "启用":"启用",
                    "简体目的地":"简体目的地",
                    "目的地":"目的地",
                    "修改时间":"修改时间",
                    "修改分拣策略":"修改分拣策略",
                    "创建人":"创建人",
                    "客户":"客户",
                    "新增":"新增",
                    "确定":"确定",
                    "目的地编码":"目的地编码",
                    "多选":"多选",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "提示":"提示",
                    "分拣策略":"分拣策略",
                    "请选择":"请选择",
                    "此操作将删除该分拣策略, 是否继续?":"此操作将删除该分拣策略, 是否继续?",
                    "启用状态":"启用状态",
                    "新增成功":"新增成功",
                    "报关方式":"报关方式",
                    "所属网点":"所属网点",
                    "货物类型":"货物类型",
                    "导出":"导出",
                    "修改人":"修改人",
                    "取消":"取消",
                    "分拣卡口":"分拣卡口",
                    "创建时间":"创建时间",
                    "走货路线必填其一":"走货路线必填其一"
                }
            },
            "baggingStrategy":{
                "baggingStrategy":{
                    "修改":"修改",
                    "规则中只能存在一段流水号规则":"规则中只能存在一段流水号规则",
                    "保存并继续":"保存并继续",
                    "英文目的地":"英文目的地",
                    "邮包互换局":"邮包互换局",
                    "修改成功":"修改成功",
                    "请选择共享网点":"请选择共享网点",
                    "目的地机场代码":"目的地机场代码",
                    "装包策略":"装包策略",
                    "查询":"查询",
                    "保存":"保存",
                    "单票限制价值":"单票限制价值",
                    "支持，,；;、多种符号(可含回车)分隔，如中国、香港或中国；美国":"支持，,；;、多种符号(可含回车)分隔，如中国、香港或中国；美国",
                    "最小单票限制申报价值不能大于最大单票限制申报价值":"最小单票限制申报价值不能大于最大单票限制申报价值",
                    "可多选":"可多选",
                    "创建人":"创建人",
                    "规则第五段不能为空":"规则第五段不能为空",
                    "自动包号":"自动包号",
                    "共享给指定":"共享给指定",
                    "多选":"多选",
                    "请选择":"请选择",
                    "注意":"注意",
                    "启用状态":"启用状态",
                    "为保证包号严谨性":"为保证包号严谨性",
                    "此操作将删除该装包策略, 是否继续?":"此操作将删除该装包策略, 是否继续?",
                    "所属网点":"所属网点",
                    "修改人":"修改人",
                    "整包限制重量":"整包限制重量",
                    "策略名称":"策略名称",
                    "删除成功":"删除成功",
                    "走货路线":"走货路线",
                    "备注":"备注",
                    "删除":"删除",
                    "关闭":"关闭",
                    "规则第三段不能为空":"规则第三段不能为空",
                    "重置":"重置",
                    "启用":"启用",
                    "简体目的地":"简体目的地",
                    "自动生成包号规则":"自动生成包号规则",
                    "目的地":"目的地",
                    "修改时间":"修改时间",
                    "单票限制申报价值":"单票限制申报价值",
                    "共享网点":"共享网点",
                    "修改装包策略":"修改装包策略",
                    "派件网点":"派件网点",
                    "最小整包限制重量不能大于最大整包限制重量":"最小整包限制重量不能大于最大整包限制重量",
                    "新增":"新增",
                    "确定":"确定",
                    "策略编码":"策略编码",
                    "目的地编码":"目的地编码",
                    "规则第三段和第五段必填":"规则第三段和第五段必填",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "提示":"提示",
                    "共享方式":"共享方式",
                    "新增装包策略":"新增装包策略",
                    "新增成功":"新增成功",
                    "限定货物类型":"限定货物类型",
                    "报关方式":"报关方式",
                    "邮局互换局":"邮局互换局",
                    "货物类型":"货物类型",
                    "导出":"导出",
                    "请输入":"请输入",
                    "取消":"取消",
                    "创建时间":"创建时间",
                    "请选择装包策略":"请选择装包策略"
                }
            },
            "ordervalidationrules":{
                "ordervalidationrules":{
                    "确定要删除吗？":"确定要删除吗？",
                    "修改":"修改",
                    "保存并继续":"保存并继续",
                    "示例单号":"示例单号",
                    "有效起始位置必须有值且大于0":"有效起始位置必须有值且大于0",
                    "优先级":"优先级",
                    "有效字符长度必须有值且大于0":"有效字符长度必须有值且大于0",
                    "规则名称":"规则名称",
                    "单号规则设置说明":"单号规则设置说明",
                    "示例单号不符合单号规则":"示例单号不符合单号规则",
                    "删除":"删除",
                    "示例单号不能为空":"示例单号不能为空",
                    "查询":"查询",
                    "关闭":"关闭",
                    "保存":"保存",
                    "示例有效单号":"示例有效单号",
                    "重置":"重置",
                    "启用":"启用",
                    "验证规则":"验证规则",
                    "修改时间":"修改时间",
                    "可多选":"可多选",
                    "请选择一行数据":"请选择一行数据",
                    "有效起始位置或有效字符长度与单号规则不符":"有效起始位置或有效字符长度与单号规则不符",
                    "创建人":"创建人",
                    "修改异常":"修改异常",
                    "单号类型":"单号类型",
                    "新增":"新增",
                    "确定":"确定",
                    "提示":"提示",
                    "修改单号验证规则":"修改单号验证规则",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "测试":"测试",
                    "删除成功！":"删除成功！",
                    "新增单号验证规则":"新增单号验证规则",
                    "启用状态":"启用状态",
                    "删除异常":"删除异常",
                    "添加成功！":"添加成功！",
                    "规则排序":"规则排序",
                    "有效字符长度":"有效字符长度",
                    "请输入":"请输入",
                    "修改人":"修改人",
                    "&不能混合其他字符一起使用":"&不能混合其他字符一起使用",
                    "取消":"取消",
                    "创建时间":"创建时间",
                    "单号规则":"单号规则",
                    "添加异常":"添加异常",
                    "有效起始位置":"有效起始位置",
                    "修改成功！":"修改成功！",
                    "原始单号AB1234567890，可设置规则为##**********；存在固定字母或数字，可设置#或*为具体字母或数字，如AB8*********；":"原始单号AB1234567890，可设置规则为##**********；存在固定字母或数字，可设置#或*为具体字母或数字，如AB8*********；",
                    "假设运单总长度10位，数字+字母且不确定字母位置，可设置规则&&&&&&&&&&；":"假设运单总长度10位，数字+字母且不确定字母位置，可设置规则&&&&&&&&&&；",
                    "&符号不能与#或者*混用。":"&符号不能与#或者*混用。",
                    "%表示包含，不限制%前单号位数，此时不能做截取":"%表示包含，不限制%前单号位数，此时不能做截取",
                }
            },


            "dest":{
                "destmag":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "设置报音":"设置报音",
                    "导出":"导出",
                    "目的地信息":"目的地信息",
                    "目的地编码":"目的地编码",
                    "目的地名称":"目的地名称",
                    "国家简码":"国家简码",
                    "英文名称":"英文名称",
                    "国家别名":"国家别名",
                    "业务类型":"业务类型",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "目的地国币别":"目的地国币别",
                    "目的地服务电话":"目的地服务电话",
                    "可多选":"可多选",
                    "多个别名":"多个别名",
                    "请用":"请用",
                    "或":"或",
                    "隔开":"隔开",
                    "主要用报价分区导入":"主要用报价分区导入",
                    "中文名称":"中文名称",
                    "备注":"备注",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "报音文件":"报音文件",
                    "序号":"序号",
                    "货物类型":"货物类型",
                    "请输入":"请输入",
                    "请选择，请重请选择！":"报音文件不能为空，请重新选择！",
                    "目的地国家币别":"目的地国家币别",
                    "目的地国服务电话":"目的地国服务电话",
                    "目的地报音":"目的地报音",
                    "创建时间":"创建时间",
                    "创建人,是否创建人？":"内容有修改,是否确认关闭？",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "新增目的地":"新增目的地",
                    "修改目的地":"修改目的地",
                    "请选择目的地":"请选择目的地",
                    "新增成功, 是新增成功?":"此操作将删除该目的地, 是否继续?",
                    "修改成功":"修改成功",
                    "此操作将删除该目的地, 是否继续?":"此操作将删除该目的地, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功":"删除成功",
                    "目的地":"目的地",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "目的地设置报音":"目的地设置报音",
                    "报音文件不能为空，请重新选择！":"报音文件不能为空，请重新选择！"
                }
            },
            "agentmanagement":{
                "agentmanagement":{
                    "新增":"新增",
                    "修改":"修改",
                    "批量修改":"批量修改",
                    "浏览":"浏览",
                    "删除":"删除",
                    "导出":"导出",
                    "代理信息":"代理信息",
                    "所属网点":"所属网点",
                    "代理编码":"代理编码",
                    "代理名称":"代理名称",
                    "代理类型":"代理类型",
                    "启用状态":"启用状态",
                    "对账员":"对账员",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "代理简码":"代理简码",
                    "代理全称":"代理全称",
                    "英文名称":"英文名称",
                    "所属国家":"所属国家",
                    "所属州":"所属州",
                    "省":"省",
                    "所属城市":"所属城市",
                    "所属邮编":"所属邮编",
                    "地址":"地址",
                    "地址2":"地址2",
                    "备注":"备注",
                    "付款信息":"付款信息",
                    "付款账号信息":"付款账号信息",
                    "银行账号":"银行账号",
                    "开户银行":"开户银行",
                    "开户人":"开户人",
                    "付款账号协议":"付款账号协议",
                    "只能上传":"只能上传",
                    "张":"张",
                    "格式":"格式",
                    "图片文件":"图片文件",
                    "不超过":"不超过",
                    "联络信息":"联络信息",
                    "序号":"序号",
                    "操作":"操作",
                    "联系人":"联系人",
                    "岗位":"岗位",
                    "电话":"电话",
                    "手机":"手机",
                    "传真":"传真",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "修改信息":"修改信息",
                    "当前选择批量修改代理":"当前选择批量修改代理",
                    "家":"家",
                    "请谨慎修改":"请谨慎修改",
                    "新增代理":"新增代理",
                    "所属州/省":"所属州/省",
                    "最后一次交货时间":"最后一次交货时间",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请输入":"请输入",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "是否删除当前代理":"是否删除当前代理",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择一行数据":"请选择一行数据",
                    "删除异常":"删除异常",
                    "删除成功！":"删除成功！",
                    "请输入代理编码":"请输入代理编码",
                    "不能存在相同联系人":"不能存在相同联系人",
                    "添加异常":"添加异常",
                    "添加成功！":"添加成功！",
                    "修改异常":"修改异常",
                    "修改成功！":"修改成功！",
                    "请选择要修改的数据":"请选择要修改的数据",
                    "请选择代理类型":"请选择代理类型",
                    "请选择对账员":"请选择对账员",
                    "请先选择要修改列":"请先选择要修改列",
                    "代理浏览":"代理浏览",
                    "获取文件路径异常":"获取文件路径异常",
                    "修改代理":"修改代理",
                    "代理管理":"代理管理",
                    "文件大小不能大于2MB":"文件大小不能大于2MB",
                    "只能上传jpeg/jpg/png文件":"只能上传jpeg/jpg/png文件",
                    "确定删除此行吗？":"确定删除此行吗？",
                    "联系人不能为空":"联系人不能为空",
                    "岗位不能为空":"岗位不能为空",
                    "手机不能为空":"手机不能为空",
                }
            },
            "cust":{
                "custSetting":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "共享":"共享",
                    "不共享":"不共享",
                    "共享给所有":"共享给所有",
                    "共享给指定":"共享给指定",
                    "导出":"导出",
                    "客户分组信息":"客户分组信息",
                    "客户组编码":"客户组编码",
                    "客户组名称":"客户组名称",
                    "所属网点":"所属网点",
                    "共享方式":"共享方式",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基本信息":"基本信息",
                    "启用":"启用",
                    "中隐藏公式":"中隐藏公式",
                    "备注":"备注",
                    "共享网点":"共享网点",
                    "可多选":"可多选",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "共享给指定网点":"共享给指定网点",
                    "网点列表":"网点列表",
                    "指定网点":"指定网点",
                    "请输入关键字":"请输入关键字",
                    "新增客户组":"新增客户组",
                    "VIP中隐藏公式":"VIP中隐藏公式",
                    "建立时间":"建立时间",
                    "建立人":"建立人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请输入":"请输入",
                    "确定要删除吗？":"确定要删除吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择一行数据":"请选择一行数据",
                    "删除异常":"删除异常",
                    "删除成功！":"删除成功！",
                    "添加异常":"添加异常",
                    "添加成功！":"添加成功！",
                    "修改异常":"修改异常",
                    "修改成功！":"修改成功！",
                    "至少选择一个网点！":"至少选择一个网点！",
                    "保存异常":"保存异常",
                    "修改共享方式成功！":"修改共享方式成功！",
                    "修改共享方式失败！":"修改共享方式失败！",
                    "修改客户组":"修改客户组",
                    "浏览客户组":"浏览客户组",
                    "客户组管理":"客户组管理",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                },

            },
            "sender":{
                "sender":{
                    "新增":"新增",
                    "修改":"修改",
                    "批量修改":"批量修改",
                    "删除":"删除",
                    "导出":"导出",
                    "寄件人管理":"寄件人管理",
                    "寄件公司":"寄件公司",
                    "寄件人":"寄件人",
                    "寄件电话":"寄件电话",
                    "所属网点":"所属网点",
                    "分类标签":"分类标签",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基本信息":"基本信息",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "所属客户":"所属客户",
                    "寄件公司别名":"寄件公司别名",
                    "多个别名请用":"多个别名请用",
                    "分割":"分割",
                    "地址信息":"地址信息",
                    "寄件地址":"寄件地址",
                    "寄件邮箱":"寄件邮箱",
                    "寄件国家":"寄件国家",
                    "寄件州":"寄件州",
                    "省":"省",
                    "寄件城市":"寄件城市",
                    "寄件邮编":"寄件邮编",
                    "联络&对接信息":"联络&对接信息",
                    "寄件人联系人":"寄件人联系人",
                    "操作":"操作",
                    "增加":"增加",
                    "联系人":"联系人",
                    "部门":"部门",
                    "业务电话":"业务电话",
                    "业务手机":"业务手机",
                    "传真":"传真",
                    "邮箱地址":"邮箱地址",
                    "备注":"备注",
                    "内部对接人信息":"内部对接人信息",
                    "销售员":"销售员",
                    "跟单员":"跟单员",
                    "港前客服":"港前客服",
                    "港后客服":"港后客服",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "修改信息":"修改信息",
                    "当前选择批量修改寄件人":"当前选择批量修改寄件人",
                    "家":"家",
                    "请谨慎修改":"请谨慎修改",
                    "请输入":"请输入",
                    "寄件地址2":"寄件地址2",
                    "寄件地址3":"寄件地址3",
                    "寄件州/省":"寄件州/省",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "修改成功！":"修改成功！",
                    "此联系人将被删除，确认继续吗？":"此联系人将被删除，确认继续吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择单行数据":"请选择单行数据",
                    "确定要删除吗？":"确定要删除吗？",
                    "请选择一行数据":"请选择一行数据",
                    "删除异常":"删除异常",
                    "删除成功！":"删除成功！",
                    "寄件公司不能为空":"寄件公司不能为空",
                    "寄件人不能为空":"寄件人不能为空",
                    "寄件电话不能为空":"寄件电话不能为空",
                    "寄件邮编不能为空":"寄件邮编不能为空",
                    "添加异常":"添加异常",
                    "添加成功！":"添加成功！",
                    "修改异常":"修改异常",
                    "请选择至少一行数据！":"请选择至少一行数据！",
                    "新增寄件人管理":"新增寄件人管理",
                    "修改寄件人管理":"修改寄件人管理",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "":"",
                }
            },
            "recipient":{
                "recipient":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "收件人":"收件人",
                    "收件税号":"收件税号",
                    "收件公司":"收件公司",
                    "收件电话":"收件电话",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "地址信息":"地址信息",
                    "收件地址":"收件地址",
                    "收件国家":"收件国家",
                    "收件城市":"收件城市",
                    "收件邮编":"收件邮编",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "请输入":"请输入",
                    "请选择共享方式":"请选择共享方式",
                    "请选择共享网点":"请选择共享网点",
                    "收件地址1":"收件地址1",
                    "收件地址2":"收件地址2",
                    "收件地址3":"收件地址3",
                    "收件州/省":"收件州/省",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "确定要删除吗？":"确定要删除吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择一行数据":"请选择一行数据",
                    "删除异常":"删除异常",
                    "删除成功！":"删除成功！",
                    "共享给指定":"共享给指定",
                    "添加异常":"添加异常",
                    "添加成功！":"添加成功！",
                    "修改异常":"修改异常",
                    "修改成功！":"修改成功！",
                    "新增收件人":"新增收件人",
                    "修改收件人":"修改收件人",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                }
            },
            "goodsalloc":{
                "goodsalloc":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "货位管理信息":"货位管理信息",
                    "所属网点":"所属网点",
                    "货位编码":"货位编码",
                    "货位类型":"货位类型",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "备注":"备注",
                    "注意":"注意",
                    "已上架运单在操作上板":"已上架运单在操作上板",
                    "装包":"装包",
                    "总运单":"总运单",
                    "退返后":"退返后",
                    "自动下架":"自动下架",
                    "保存":"保存",
                    "关闭":"关闭",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "创建人":"创建人",
                    "创建时间":"创建时间",
                    "修改人":"修改人",
                    "修改时间":"修改时间",
                    "新增货位":"新增货位",
                    "修改货位":"修改货位",
                    "请选择货位":"请选择货位",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "此操作将删除该目的地, 是否继续?":"此操作将删除该目的地, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择目的地":"请选择目的地",
                    "删除成功":"删除成功",
                    "货位管理":"货位管理",
                    "没有数据，请重新查询":"没有数据，请重新查询",
                }
            },
            "scan":{
                "scanMag":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "货位管理信息":"货位管理信息",
                    "扫描编码":"扫描编码",
                    "扫描名称":"扫描名称",
                    "扫描分段":"扫描分段",
                    "港后货物状态":"港后货物状态",
                    "标准状态":"标准状态",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "排列顺序":"排列顺序",
                    "扫描分段(可多选)":"扫描分段(可多选)",
                    "中文备注":"中文备注",
                    "英文备注":"英文备注",
                    "异常":"异常",
                    "注意":"注意",
                    "属于异常操作":"属于异常操作",
                    "需重点关注":"需重点关注",
                    "已取件":"已取件",
                    "属于港后状态":"属于港后状态",
                    "勾选后会识别对应运单为已取件状态":"勾选后会识别对应运单为已取件状态",
                    "结案":"结案",
                    "表示已结束":"表示已结束",
                    "无需关注":"无需关注",
                    "系统标准状态":"系统标准状态",
                    "不允许随意修改":"不允许随意修改",
                    "客户可视":"客户可视",
                    "允许客户通过网站或对接显示的状态":"允许客户通过网站或对接显示的状态",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "新增扫描状态":"新增扫描状态",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "请输入扫描编码!":"请输入扫描编码!",
                    "请输入扫描名称!":"请输入扫描名称!",
                    "请输入扫描分段!":"请输入扫描分段!",
                    "新增扫描状态成功":"新增扫描状态成功",
                    "修改扫描状态成功":"修改扫描状态成功",
                    "扫描状态":"扫描状态",
                    "标准数据无法删除！":"标准数据无法删除！",
                    "此操作将删除该扫描状态, 是否继续?":"此操作将删除该扫描状态, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择扫描状态":"请选择扫描状态",
                    "扫描状态删除成功":"扫描状态删除成功",
                    "扫描状态删除失败！":"扫描状态删除失败！",
                    "修改扫描状态":"修改扫描状态",
                    "WISH 推送编码":"WISH 推送编码",
                    "ICBU 推送编码":"ICBU 推送编码",
                    "存在平台编码时，api_code必填，客户可视必须勾选":"存在平台编码时，api_code必填，客户可视必须勾选"
                }
            },
            "problemstatus":{
                "problemstatus":{
                    "新增":"新增",
                    "新增港前问题":"新增港前问题",
                    "新增港后问题":"新增港后问题",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "问题状态":"问题状态",
                    "问题编码":"问题编码",
                    "问题名称":"问题名称",
                    "问题大类":"问题大类",
                    "问题类型":"问题类型",
                    "标准状态":"标准状态",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "中文备注":"中文备注",
                    "英文备注":"英文备注",
                    "收件标识问题件":"收件标识问题件",
                    "收件时":"收件时",
                    "自动标识问题件":"自动标识问题件",
                    "打单标识问题件":"打单标识问题件",
                    "打单时":"打单时",
                    "排列顺序":"排列顺序",
                    "收件后":"收件后",
                    "客户申请暂扣":"客户申请暂扣",
                    "标识问题件":"标识问题件",
                    "运单修改重新排货时标":"运单修改重新排货时标",
                    "识问题件":"识问题件",
                    "处理信息":"处理信息",
                    "客户可视":"客户可视",
                    "勾选":"勾选",
                    "此问题件客户可视":"此问题件客户可视",
                    "用于对外问题件显示":"用于对外问题件显示",
                    "处理时限":"处理时限",
                    "港前按小时":"港前按小时",
                    "港后按天":"港后按天",
                    "默认补收科目":"默认补收科目",
                    "通知岗位":"通知岗位",
                    "可多选":"可多选",
                    "指定处理岗位":"指定处理岗位",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "需回复":"需回复",
                    "登记":"登记",
                    "回复中":"回复中",
                    "可多次":"可多次",
                    "已处理":"已处理",
                    "天":"天",
                    "不设置":"不设置",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "申请暂扣标识问题件":"申请暂扣标识问题件",
                    "重新排货标识问题件":"重新排货标识问题件",
                    "需要回复":"需要回复",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "未选择数据，无法修改！":"未选择数据，无法修改！",
                    "新增港前问题状态":"新增港前问题状态",
                    "修改港前问题状态":"修改港前问题状态",
                    "标准状态无法修改":"标准状态无法修改",
                    "请选择问题状态":"请选择问题状态",
                    "新增港后问题状态":"新增港后问题状态",
                    "修改港后问题状态":"修改港后问题状态",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除该问题状态, 是否继续?":"此操作将删除该问题状态, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "标准状态无法删除":"标准状态无法删除",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                }
            },
            "arded":{
                "ardedmag":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "科目管理":"科目管理",
                    "科目代号":"科目代号",
                    "科目名称":"科目名称",
                    "收付方向":"收付方向",
                    "科目对象":"科目对象",
                    "允许重复补录":"允许重复补录",
                    "注：费用补录，默认不允许重复科目；勾选后，补录时，允许录入重复数据":"注：费用补录，默认不允许重复科目；勾选后，补录时，允许录入重复数据",
                    "标准状态":"标准状态",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "可选择多个科目对象":"可选择多个科目对象",
                    "备注":"备注",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "全部":"全部",
                    "是":"是",
                    "否":"否",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "标准科目":"标准科目",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "新增科目":"新增科目",
                    "修改科目":"修改科目",
                    "标准科目无法修改":"标准科目无法修改",
                    "请选择科目":"请选择科目",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除该科目, 是否继续?":"此操作将删除该科目, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "标准科目无法删除":"标准科目无法删除",
                    "删除成功":"删除成功",
                    "科目":"科目",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                },
                "acctarded":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "资金账户":"资金账户",
                    "所属网点":"所属网点",
                    "资金账户编码":"资金账户编码",
                    "资金账户名称":"资金账户名称",
                    "开户人":"开户人",
                    "账户分类":"账户分类",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "账户币别":"账户币别",
                    "银行账号":"银行账号",
                    "开户银行":"开户银行",
                    "收款手续费比例":"收款手续费比例",
                    "最低手续费":"最低手续费",
                    "备注":"备注",
                    "共享网点":"共享网点",
                    "共享方式":"共享方式",
                    "可多选":"可多选",
                    "说明":"说明",
                    "将资金账户共享给其他网点":"将资金账户共享给其他网点",
                    "共享网点可通过当前资金账户进行客户代收代付业务":"共享网点可通过当前资金账户进行客户代收代付业务",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "银行账户":"银行账户",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "余额":"余额",
                    "收款手续费比例(%)":"收款手续费比例(%)",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "新增资金账户":"新增资金账户",
                    "修改资金账户":"修改资金账户",
                    "请选择资金账户":"请选择资金账户",
                    "请选择共享网点":"请选择共享网点",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除该资金账户, 是否继续?":"此操作将删除该资金账户, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                },
                "szarded":{
                    "增加":"增加",
                    "修改":"修改",
                    "删除":"删除",
                    "新增":"新增",
                    "科目编码":"科目编码",
                    "科目名称":"科目名称",
                    "一级分类":"一级分类",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "二级分类":"二级分类",
                    "核销类型":"核销类型",
                    "备注":"备注",
                    "标准科目":"标准科目",
                    "收入类科目":"收入类科目",
                    "允许在客户收款":"允许在客户收款",
                    "充值":"充值",
                    "退款时录入":"退款时录入",
                    "支出类科目":"支出类科目",
                    "允许在代理付款时录入":"允许在代理付款时录入",
                    "费用类科目":"费用类科目",
                    "允许在费用报销录入":"允许在费用报销录入",
                    "非标准客户只能在会计科目中录入":"非标准客户只能在会计科目中录入",
                    "核销科目":"核销科目",
                    "核销科目允许在客户收付款":"核销科目允许在客户收付款",
                    "代理付款环节核销应收账款":"代理付款环节核销应收账款",
                    "公共科目":"公共科目",
                    "公共科目允许在客户收款":"公共科目允许在客户收款",
                    "代理付款":"代理付款",
                    "费用报销中使用":"费用报销中使用",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "标准二级分类":"标准二级分类",
                    "二级分类编码":"二级分类编码",
                    "二级分类名称":"二级分类名称",
                    "建立时间":"建立时间",
                    "建立人":"建立人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请输入":"请输入",
                    "请输入科目编码":"请输入科目编码",
                    "请输入科目名称":"请输入科目名称",
                    "请选择一级分类":"请选择一级分类",
                    "请选择二级分类":"请选择二级分类",
                    "获取二级分类树异常":"获取二级分类树异常",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "新增二级分类":"新增二级分类",
                    "修改二级分类":"修改二级分类",
                    "确定要删除吗？":"确定要删除吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功！":"删除成功！",
                    "新增成功":"新增成功",
                    "修改成功！":"修改成功！",
                    "新增收支科目":"新增收支科目",
                    "标准科目不允许修改！":"标准科目不允许修改！",
                    "修改收支科目":"修改收支科目",
                    "请选择需要修改的数据":"请选择需要修改的数据",
                    "请选择核销类型！":"请选择核销类型！",
                    "标准科目不允许删除！":"标准科目不允许删除！",
                    "请选择需要删除的数据":"请选择需要删除的数据",
                }
            },
            "shopee":{
                "shopeeServiceCode":{
                    "Shopee Service Code":"Shopee Service Code",
                    "国家简码":"国家简码",
                    "分拣码":"分拣码",
                    "Service Code":"Service Code",
                    "P/T":"P/T",
                    "EC/SC":"EC/SC",
                    "LM":"LM",
                    "新增 Shopee Service Code":"新增 Shopee Service Code",
                    "修改 Shopee Service Code":"修改 Shopee Service Code",
                    "基本信息":"基本信息",
                    "注意":"注意",
                    "导出shopee daily report时，若分拣码未配置对应的service code，则整个导出任务失败":"导出shopee daily report时，若分拣码未配置对应的service code，则整个导出任务失败",
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "备注":"备注",
                    "保存":"保存",
                    "关闭":"关闭",
                    "全部":"全部",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请选择数据":"请选择数据",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除当前选择数据, 是否继续?":"此操作将删除当前选择数据, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                },
                "acctarded":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "资金账户":"资金账户",
                    "所属网点":"所属网点",
                    "资金账户编码":"资金账户编码",
                    "资金账户名称":"资金账户名称",
                    "开户人":"开户人",
                    "账户分类":"账户分类",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "账户币别":"账户币别",
                    "银行账号":"银行账号",
                    "开户银行":"开户银行",
                    "收款手续费比例":"收款手续费比例",
                    "最低手续费":"最低手续费",
                    "备注":"备注",
                    "共享网点":"共享网点",
                    "共享方式":"共享方式",
                    "可多选":"可多选",
                    "说明":"说明",
                    "将资金账户共享给其他网点":"将资金账户共享给其他网点",
                    "共享网点可通过当前资金账户进行客户代收代付业务":"共享网点可通过当前资金账户进行客户代收代付业务",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "银行账户":"银行账户",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "余额":"余额",
                    "收款手续费比例(%)":"收款手续费比例(%)",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "新增资金账户":"新增资金账户",
                    "修改资金账户":"修改资金账户",
                    "请选择资金账户":"请选择资金账户",
                    "请选择共享网点":"请选择共享网点",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除该资金账户, 是否继续?":"此操作将删除该资金账户, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                },
                "szarded":{
                    "增加":"增加",
                    "修改":"修改",
                    "删除":"删除",
                    "新增":"新增",
                    "科目编码":"科目编码",
                    "科目名称":"科目名称",
                    "一级分类":"一级分类",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "二级分类":"二级分类",
                    "核销类型":"核销类型",
                    "备注":"备注",
                    "标准科目":"标准科目",
                    "收入类科目":"收入类科目",
                    "允许在客户收款":"允许在客户收款",
                    "充值":"充值",
                    "退款时录入":"退款时录入",
                    "支出类科目":"支出类科目",
                    "允许在代理付款时录入":"允许在代理付款时录入",
                    "费用类科目":"费用类科目",
                    "允许在费用报销录入":"允许在费用报销录入",
                    "非标准客户只能在会计科目中录入":"非标准客户只能在会计科目中录入",
                    "核销科目":"核销科目",
                    "核销科目允许在客户收付款":"核销科目允许在客户收付款",
                    "代理付款环节核销应收账款":"代理付款环节核销应收账款",
                    "公共科目":"公共科目",
                    "公共科目允许在客户收款":"公共科目允许在客户收款",
                    "代理付款":"代理付款",
                    "费用报销中使用":"费用报销中使用",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "标准二级分类":"标准二级分类",
                    "二级分类编码":"二级分类编码",
                    "二级分类名称":"二级分类名称",
                    "建立时间":"建立时间",
                    "建立人":"建立人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请输入":"请输入",
                    "请输入科目编码":"请输入科目编码",
                    "请输入科目名称":"请输入科目名称",
                    "请选择一级分类":"请选择一级分类",
                    "请选择二级分类":"请选择二级分类",
                    "获取二级分类树异常":"获取二级分类树异常",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "新增二级分类":"新增二级分类",
                    "修改二级分类":"修改二级分类",
                    "确定要删除吗？":"确定要删除吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功！":"删除成功！",
                    "新增成功":"新增成功",
                    "修改成功！":"修改成功！",
                    "新增收支科目":"新增收支科目",
                    "标准科目不允许修改！":"标准科目不允许修改！",
                    "修改收支科目":"修改收支科目",
                    "请选择需要修改的数据":"请选择需要修改的数据",
                    "请选择核销类型！":"请选择核销类型！",
                    "标准科目不允许删除！":"标准科目不允许删除！",
                    "请选择需要删除的数据":"请选择需要删除的数据",
                }
            },
            "invoice":{
                "invoiceformula":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "浏览":"浏览",
                    "启用":"启用",
                    "停用":"停用",
                    "导出":"导出",
                    "账单公式":"账单公式",
                    "公式编码":"公式编码",
                    "收付方向":"收付方向",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基本信息":"基本信息",
                    "默认公式":"默认公式",
                    "自动审核":"自动审核",
                    "新增账单公式":"新增账单公式",
                    "结算对象":"结算对象",
                    "浏览账单公式":"浏览账单公式",
                    "归属收支科目":"归属收支科目",
                    "描述":"描述",
                    "账单号码规则":"账单号码规则",
                    "段":"段",
                    "账单中文抬头":"账单中文抬头",
                    "账单英文抬头":"账单英文抬头",
                    "科目公式":"科目公式",
                    "科目":"科目",
                    "可多选":"可多选",
                    "账单号码规则说明":"账单号码规则说明",
                    "最多可由":"最多可由",
                    "段组成":"段组成",
                    "第":"第",
                    "段可以为网点简码":"段可以为网点简码",
                    "年":"年",
                    "月":"月",
                    "流水号连接而成":"流水号连接而成",
                    "段为固定位":"段为固定位",
                    "流水号是必须项":"流水号是必须项",
                    "只允许一项":"只允许一项",
                    "保存":"保存",
                    "关闭":"关闭",
                    "客户":"客户",
                    "应收":"应收",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "+科目":"+科目",
                    "-科目":"-科目",
                    "最近被使用时间":"最近被使用时间",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "修改账单公式":"修改账单公式",
                    "请选择账单公式":"请选择账单公式",
                    "账单号码规则中必须有流水号":"账单号码规则中必须有流水号",
                    "账单号码规则中流水号只允许一项":"账单号码规则中流水号只允许一项",
                    ">这些科目已经删除，是否确认保存？":">这些科目已经删除，是否确认保存？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "新增成功！":"新增成功！",
                    "修改成功！":"修改成功！",
                    "新增成功":"新增成功",
                    "此操作将删除该账单公式, 是否继续?":"此操作将删除该账单公式, 是否继续?",
                    "删除成功":"删除成功",
                    "此操作将启用该账单公式, 是否继续?":"此操作将启用该账单公式, 是否继续?",
                    "请选择已停用的账单公式进行启用！":"请选择已停用的账单公式进行启用！",
                    "启用成功":"启用成功",
                    "此操作将停用该账单公式, 是否继续?":"此操作将停用该账单公式, 是否继续?",
                    "请选择已启用账单公式进行停用！":"请选择已启用账单公式进行停用！",
                    "停用成功":"停用成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                }
            },
            "curexch":{
                "curexchset":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "其他汇率":"其他汇率",
                    "导出":"导出",
                    "汇率":"汇率",
                    "所属网点":"所属网点",
                    "换算币别":"换算币别",
                    "启用状态":"启用状态",
                    "只显示最新汇率":"只显示最新汇率",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "共享方式":"共享方式",
                    "生效日期":"生效日期",
                    "选择日期":"选择日期",
                    "修改汇率":"修改汇率",
                    "共享网点":"共享网点",
                    "原币别":"原币别",
                    "换算汇率":"换算汇率",
                    "网点本位币":"网点本位币",
                    "注意":"注意",
                    "换算汇率为将原币别转换为网点本位币的汇率":"换算汇率为将原币别转换为网点本位币的汇率",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "请选择":"请选择",
                    "请输入":"请输入",
                    "原币种":"原币种",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "新增汇率":"新增汇率",
                    "请选择汇率":"请选择汇率",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除该汇率, 是否继续?":"此操作将删除该汇率, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                }
            },
            "outboxsetup":{
                "outboxsetup":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "发件箱地址":"发件箱地址",
                    "邮箱类型":"邮箱类型",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "设置信息":"设置信息",
                    "启用":"启用",
                    "发件箱类型":"发件箱类型",
                    "可多选":"可多选",
                    "服务器地址":"服务器地址",
                    "服务器端口":"服务器端口",
                    "邮件服务器协议":"邮件服务器协议",
                    "用户名":"用户名",
                    "密码":"密码",
                    "发送间隔":"发送间隔",
                    "秒":"秒",
                    "保存":"保存",
                    "关闭":"关闭",
                    "新增发件箱":"新增发件箱",
                    "请输入发件箱地址":"请输入发件箱地址",
                    "请选择发件箱类型":"请选择发件箱类型",
                    "请输入服务器地址":"请输入服务器地址",
                    "请输入服务器端口":"请输入服务器端口",
                    "请选择邮件服务器协议":"请选择邮件服务器协议",
                    "请输入用户名":"请输入用户名",
                    "请输入密码":"请输入密码",
                    "请输入发送间隔(秒)":"请输入发送间隔(秒)",
                    "发送间隔(秒)":"发送间隔(秒)",
                    "首次发送时间":"首次发送时间",
                    "使用次数":"使用次数",
                    "最后使用时间":"最后使用时间",
                    "创建人":"创建人",
                    "创建时间":"创建时间",
                    "修改人":"修改人",
                    "修改时间":"修改时间",
                    "发件箱地址中没有“@”字符":"发件箱地址中没有“@”字符",
                    "服务器端口必须大于0":"服务器端口必须大于0",
                    "发送间隔必须大于0":"发送间隔必须大于0",
                    "添加异常":"添加异常",
                    "添加成功！":"添加成功！",
                    "修改异常":"修改异常",
                    "修改成功！":"修改成功！",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "修改发件箱":"修改发件箱",
                    "是否确认删除当前选择数据？":"是否确认删除当前选择数据？",
                    "删除成功！":"删除成功！",
                }
            },
            "pay":{
                "payonline":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "支付公司":"支付公司",
                    "支付方式":"支付方式",
                    "支付产品编码":"支付产品编码",
                    "商户编码":"商户编码",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "启用":"启用",
                    "支付公司用于区分支付类型的编码":"支付公司用于区分支付类型的编码",
                    "客户编码":"客户编码",
                    "在支付公司注册的客户编码":"在支付公司注册的客户编码",
                    "资金账户":"资金账户",
                    "充值成功后":"充值成功后",
                    "生成客户收款记录时填入的资金账户":"生成客户收款记录时填入的资金账户",
                    "手续费比例":"手续费比例",
                    "最低手续费":"最低手续费",
                    "直接从金额中扣除手续费":"直接从金额中扣除手续费",
                    "剩余金额作为客户的到账金额":"剩余金额作为客户的到账金额",
                    "充值时":"充值时",
                    "充值金额":"充值金额",
                    "到账金额":"到账金额",
                    "充值描述":"充值描述",
                    "充值时的商品名称":"充值时的商品名称",
                    "备注":"备注",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "支付公司编码":"支付公司编码",
                    "描述":"描述",
                    "新增在线充值规则":"新增在线充值规则",
                    "修改在线充值规则":"修改在线充值规则",
                    "请选择一条数据":"请选择一条数据",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除该在线充值规则, 是否继续?":"此操作将删除该在线充值规则, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择在线充值规则":"请选择在线充值规则",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                }
            }
        },


        "bms":{
            "quotepackingfee":{
                "quotepackingfeeotherexch":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "导出":"导出",
                    "其他汇率":"其他汇率",
                    "换算币别":"换算币别",
                    "查询":"查询",
                    "重置":"重置",
                    "基础信息":"基础信息",
                    "生效日期":"生效日期",
                    "新增汇率":"新增汇率",
                    "原币别":"原币别",
                    "换算汇率":"换算汇率",
                    "网点本位币":"网点本位币",
                    "注意":"注意",
                    "换算汇率为将原币别转换为网点本位币的汇率":"换算汇率为将原币别转换为网点本位币的汇率",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "原币种":"原币种",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请选择":"请选择",
                    "请输入":"请输入",
                    "修改汇率":"修改汇率",
                    "请选择汇率":"请选择汇率",
                    "此操作将删除该汇率, 是否继续?":"此操作将删除该汇率, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                }
            }
        },


        "tms": {
            "manifest": {
                "manifest": {
                    "保存":"保存",
                    "取件模式":"取件模式",
                    "客户":"客户",
                    "报关方式":"报关方式",
                    "取件员":"取件员",
                    "运单号码":"运单号码",
                    "重置单号":"重置单号",
                    "参考编号":"参考编号",
                    "转单号码":"转单号码",
                    "指定路线":"指定路线",
                    "目的地":"目的地",
                    "货物类型":"货物类型",
                    "收件邮编":"收件邮编",
                    "偏远":"偏远",
                    "收件城市":"收件城市",
                    "申报价值":"申报价值",
                    "包装类型":"包装类型",
                    "件数":"件数",
                    "称重":"称重",
                    "收费实重":"收费实重",
                    "收费材重":"收费材重",
                    "收费重":"收费重",
                    "中文品名":"中文品名",
                    "收件备注":"收件备注",
                    "预报重量":"预报重量",
                    "预报指定路线":"预报指定路线",
                    "其他科目":"其他科目",
                    "金额":"金额",
                    "币别":"币别",
                    "收件问题":"收件问题",
                    "付款方式":"付款方式",
                    "到付款":"到付款",
                    "税金付款":"税金付款",
                    "代收款":"代收款",
                    "新增":"新增",
                    "修改":"修改",
                    "取消":"取消",
                    "删除":"删除",
                    "打印条码":"打印条码",
                    "收货标签":"收货标签",
                    "发票标签":"发票标签",
                    "打印清单":"打印清单",
                    "单件称重":"单件称重",
                    "合并计算":"合并计算",
                    "收货提交":"收货提交",
                    "设置":"设置",
                    "全部":"全部",
                    "单件信息":"单件信息",
                    "运单信息":"运单信息",
                    "注意":"注意",
                    "以下录入的都为单件信息":"以下录入的都为单件信息",
                    "单件进位规则":"单件进位规则",
                    "单票计抛规则":"单票计抛规则",
                    "单票进位规则":"单票进位规则",
                    "序号":"序号",
                    "操作":"操作",
                    "实重":"实重",
                    "长":"长",
                    "宽":"宽",
                    "高":"高",
                    "除以数":"除以数",
                    "材重":"材重",
                    "最小重量":"最小重量",
                    "生效类型":"生效类型",
                    "包装项目":"包装项目",
                    "包装费":"包装费",
                    "包装说明":"包装说明",
                    "子单号码":"子单号码",
                    "同步复制实重":"同步复制实重",
                    "尺寸复制":"尺寸复制",
                    "全部清除":"全部清除",
                    "全部删除":"全部删除",
                    "导出":"导出",
                    "关闭":"关闭",
                    "其他收件客户":"其他收件客户",
                    "显示当前网点":"显示当前网点",
                    "当前收货用户的数据":"当前收货用户的数据",
                    "显示当前网点数据":"显示当前网点数据",
                    "收货用户":"收货用户",
                    "客户编码":"客户编码",
                    "客户名称":"客户名称",
                    "票数":"票数",
                    "运费":"运费",
                    "其他费用":"其他费用",
                    "查询":"查询",
                    "单价":"单价",
                    "最低价格":"最低价格",
                    "最高价格":"最高价格",
                    "偏远费":"偏远费",
                    "含燃油":"含燃油",
                    "列表双击可选中邮编":"列表双击可选中邮编",
                    "待确认的收货问题":"待确认的收货问题",
                    "问题编码":"问题编码",
                    "问题状态":"问题状态",
                    "问题描述":"问题描述",
                    "可选问题状态":"可选问题状态",
                    "请输入内容":"请输入内容",
                    "待确认问题":"待确认问题",
                    "收货提交后自动生成港前问题件":"收货提交后自动生成港前问题件",
                    "由客服跟进处理":"由客服跟进处理",
                    "收件录单设置":"收件录单设置",
                    "扫描规则":"扫描规则",
                    "强制输入尺寸":"强制输入尺寸",
                    "邮编或城市必填其一":"邮编或城市必填其一",
                    "件数空格时打印收货标签":"件数空格时打印收货标签",
                    "件数空格时打印发票标签":"件数空格时打印发票标签",
                    "允许跨网点收货":"允许跨网点收货",
                    "保存时计算运费":"保存时计算运费",
                    "保留上一票信息":"保留上一票信息",
                    "运费为":"运费为",
                    "时处理":"时处理",
                    "限制收货":"限制收货",
                    "确认提示":"确认提示",
                    "不提示不限制":"不提示不限制",
                    "提示不限制":"提示不限制",
                    "子单生成规则":"子单生成规则",
                    "固定位":"固定位",
                    "流水号位数":"流水号位数",
                    "最大打印件数":"最大打印件数",
                    "短信发送":"短信发送",
                    "预报订单列表":"预报订单列表",
                    "多次扫描记录列表":"多次扫描记录列表",
                    "继续合并":"继续合并",
                    "请选择客户":"请选择客户",
                    "请输入运单号码":"请输入运单号码",
                    "请选择报关方式":"请选择报关方式",
                    "请选择指定路线":"请选择指定路线",
                    "请选择目的地":"请选择目的地",
                    "请选择货物类型":"请选择货物类型",
                    "请选择包装类型":"请选择包装类型",
                    "请输入件数":"请输入件数",
                    "请输入收费实重":"请输入收费实重",
                    "请选择付款方式":"请选择付款方式",
                    "请选择税金付款":"请选择税金付款",
                    "请选择取件员":"请选择取件员",
                    "待确认":"待确认",
                    "英文品名":"英文品名",
                    "计抛方式":"计抛方式",
                    "预报重":"预报重",
                    "寄件日期":"寄件日期",
                    "国家简码":"国家简码",
                    "州/省":"州/省",
                    "城市":"城市",
                    "起始邮编":"起始邮编",
                    "终止邮编":"终止邮编",
                    "备注":"备注",
                    "扫描单号":"扫描单号",
                    "扫描次数":"扫描次数",
                    "预报件数":"预报件数",
                    "目的地名":"目的地名",
                    "合并成功!":"合并成功!",
                    "合并计算失败!":"合并计算失败!",
                    "参考编号<":"参考编号<",
                    ">已存在，请尽量避免重复数据。是否继续录单？":">已存在，请尽量避免重复数据。是否继续录单？",
                    "提示":"提示",
                    "确定":"确定",
                    "收件城市或收件邮编不明确，不能直接选择":"收件城市或收件邮编不明确，不能直接选择",
                    "未查询到偏远信息!":"未查询到偏远信息!",
                    "指定路线不能为空":"指定路线不能为空",
                    "目的地不能为空":"目的地不能为空",
                    "无可合并计算数据!":"无可合并计算数据!",
                    "无可合并计算数据 !":"无可合并计算数据 !",
                    "{附加项目:":"{附加项目:",
                    "单件取大不计抛":"单件取大不计抛",
                    ",偏远":",偏远",
                    "订单预报重量为":"订单预报重量为",
                    "，与收货重":"，与收货重",
                    "不符，请检查排货是否准确":"不符，请检查排货是否准确",
                    ",偏远费：":",偏远费：",
                    "无数据":"无数据",
                    "D类":"D类",
                    "单独报关":"单独报关",
                    ",单独报关,":",单独报关,",
                    "单独报关,":"单独报关,",
                    ",单独报关":",单独报关",
                    "请先选择客户":"请先选择客户",
                    "客户申请暂扣，限制收货":"客户申请暂扣，限制收货",
                    "运单号码<":"运单号码<",
                    ">的录单网点为<":">的录单网点为<",
                    ">,不属于当前网点收货的运单":">,不属于当前网点收货的运单",
                    "当前指定路线的计抛方式发生变化，收费重由<":"当前指定路线的计抛方式发生变化，收费重由<",
                    ">变为<":">变为<",
                    "当前指定路线的计抛方式发生变化，请重新保存单件信息":"当前指定路线的计抛方式发生变化，请重新保存单件信息",
                    "当前指定路线的材积除以数由<":"当前指定路线的材积除以数由<",
                    ">改为<":">改为<",
                    ">，请重新保存单件信息":">，请重新保存单件信息",
                    "关税预付":"关税预付",
                    "第三方关税":"第三方关税",
                    ",关税预付,":",关税预付,",
                    "关税预付,":"关税预付,",
                    ",关税预付":",关税预付",
                    ",第三方关税,":",第三方关税,",
                    "第三方关税,":"第三方关税,",
                    ",第三方关税":",第三方关税",
                    "偏远邮编":"偏远邮编",
                    "偏远,":"偏远,",
                    ",偏远,":",偏远,",
                    "收费重为0，不允许保存":"收费重为0，不允许保存",
                    "请输入转单号码":"请输入转单号码",
                    "请输入参考编号":"请输入参考编号",
                    "指定路线<":"指定路线<",
                    ">允许收货件数为<":">允许收货件数为<",
                    ">，范围外不允许收货":">，范围外不允许收货",
                    ">允许收货实重为<":">允许收货实重为<",
                    ">允许收货材重为<":">允许收货材重为<",
                    ">允许收货重量为<":">允许收货重量为<",
                    "指定路线限制货物类型<":"指定路线限制货物类型<",
                    ">，不允许收货":">，不允许收货",
                    "件数与单件信息不匹配，请重新输入!":"件数与单件信息不匹配，请重新输入!",
                    "请选择到付币别!":"请选择到付币别!",
                    "请输入申报价值币别!":"请输入申报价值币别!",
                    "请选择代收币别!":"请选择代收币别!",
                    "请选择科目!":"请选择科目!",
                    "请选择科目币别!":"请选择科目币别!",
                    "收件邮编和收件城市不能同时为空，请重新输入!":"收件邮编和收件城市不能同时为空，请重新输入!",
                    "运费为0，不允许保存":"运费为0，不允许保存",
                    "运费为0，是否继续保存？":"运费为0，是否继续保存？",
                    "运费为0！":"运费为0！",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "票":"票",
                    "客户无效，请重新选择!":"客户无效，请重新选择!",
                    "客户已停用，不能收货!":"客户已停用，不能收货!",
                    "客户已暂停，不能收货!":"客户已暂停，不能收货!",
                    "不能收货":"不能收货",
                    "允许收货":"允许收货",
                    "指定路线的收费重的材积除以数与单件进位规则发生变化，收费材积和收费重将重新计算":"指定路线的收费重的材积除以数与单件进位规则发生变化，收费材积和收费重将重新计算",
                    "请选择指定路线!":"请选择指定路线!",
                    "录入件数为":"录入件数为",
                    "件，而单件数为":"件，而单件数为",
                    "件，是否清除多余的件数":"件，是否清除多余的件数",
                    "实重材重同时为0，不允许保存和关闭":"实重材重同时为0，不允许保存和关闭",
                    "存在为0数据,不允许保存和关闭":"存在为0数据,不允许保存和关闭",
                    "存在为空数据,不允许保存和关闭":"存在为空数据,不允许保存和关闭",
                    "存在不收件，请重新填写标红件！":"存在不收件，请重新填写标红件！",
                    "单件信息件数与运单件数不一致，是否继续保存":"单件信息件数与运单件数不一致，是否继续保存",
                    "请选择需要删除的单件信息!":"请选择需要删除的单件信息!",
                    "确认删除当前单件信息？":"确认删除当前单件信息？",
                    "确定删除当前所有单件信息？":"确定删除当前所有单件信息？",
                    "合计":"合计",
                    "客户数：":"客户数：",
                    "内容有修改,是否取消编辑？":"内容有修改,是否取消编辑？",
                    "请选择运单":"请选择运单",
                    "此操作将删除该运单, 是否继续?":"此操作将删除该运单, 是否继续?",
                    "删除成功":"删除成功",
                    "请在右表选择客户后再提交":"请在右表选择客户后再提交",
                    "没有待提交运单，请保存运单后再提交":"没有待提交运单，请保存运单后再提交",
                    "没有可以提交的运单，请检查！":"没有可以提交的运单，请检查！",
                    "提交成功！":"提交成功！",
                    "实重材重取大":"实重材重取大",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "没有待提交运单，请保存运单后再打印":"没有待提交运单，请保存运单后再打印",
                    "打印完成":"打印完成",
                    "请在右表选择客户后再打印":"请在右表选择客户后再打印",
                    "流水号位数不够，请重新设置":"流水号位数不够，请重新设置",
                    "子单生成规则未设置，请重新设置":"子单生成规则未设置，请重新设置",
                    "问题描述不能为空":"问题描述不能为空",
                    "保存成功":"保存成功",
                    "根据指定路线<":"根据指定路线<",
                    ">设置的邮编目的地规则，收件邮编<":">设置的邮编目的地规则，收件邮编<",
                    ">分拣的目的地为<":">分拣的目的地为<",
                },
                "importmodify": {
                    "导入模版":"导入模版",
                    "模版下载":"模版下载",
                    "新增模板":"新增模板",
                    "寄件网点":"寄件网点",
                    "导入":"导入",
                    "导入文件格式支持":"导入文件格式支持",
                    "文件大小不超过":"文件大小不超过",
                    "导入时":"导入时",
                    "请确认导入模板中表头的完整性":"请确认导入模板中表头的完整性",
                    "导入重量小于收费重时":"导入重量小于收费重时",
                    "不修改":"不修改",
                    "适用于提前导入代理重量":"适用于提前导入代理重量",
                    "批次号":"批次号",
                    "导入文件":"导入文件",
                    "导入时间":"导入时间",
                    "状态":"状态",
                    "总行数":"总行数",
                    "错误行数":"错误行数",
                    "文件下载":"文件下载",
                    "历史日志":"历史日志",
                    "导入历史日志":"导入历史日志",
                    "请输入":"请输入",
                    "行号":"行号",
                    "运单号码":"运单号码",
                    "错误说明":"错误说明",
                    "请选择模版！":"请选择模版！",
                    "运单修改标准模版":"运单修改标准模版",
                    "请选择导入模版！":"请选择导入模版！",
                    "请选择寄件网点！":"请选择寄件网点！",
                    "导入文件不能超过10MB":"导入文件不能超过10MB",
                    "解析中":"解析中",
                    "失败":"失败",
                    "导入中":"导入中",
                    "上传中":"上传中",
                    "上传失败":"上传失败",
                    "解析失败":"解析失败",
                    "验证中":"验证中",
                    "验证失败":"验证失败",
                    "成功":"成功",
                    "运单修改成功":"运单修改成功",
                },
                "manifestSpecialLine": {
                    "保存":"保存",
                    "问题件":"问题件",
                    "面单打印":"面单打印",
                    "设置面单默认格式":"设置面单默认格式",
                    "设置":"设置",
                    "基本信息":"基本信息",
                    "收件人":"收件人",
                    "客户":"客户",
                    "寄件网点":"寄件网点",
                    "指定路线":"指定路线",
                    "目的地":"目的地",
                    "寄件日期":"寄件日期",
                    "运单号码":"运单号码",
                    "参考编号":"参考编号",
                    "走货路线":"走货路线",
                    "收件税号":"收件税号",
                    "选择收件人":"选择收件人",
                    "收件公司":"收件公司",
                    "收件电话":"收件电话",
                    "收件地址":"收件地址",
                    "收件城市":"收件城市",
                    "收件邮编":"收件邮编",
                    "单件信息":"单件信息",
                    "序号":"序号",
                    "操作":"操作",
                    "删除":"删除",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "件数":"件数",
                    "实重":"实重",
                    "长":"长",
                    "宽":"宽",
                    "高":"高",
                    "体积":"体积",
                    "数量":"数量",
                    "单价":"单价",
                    "总价":"总价",
                    "海关编码":"海关编码",
                    "包装类型":"包装类型",
                    "货物类型":"货物类型",
                    "报关方式":"报关方式",
                    "付款方式":"付款方式",
                    "总件数":"总件数",
                    "收费重":"收费重",
                    "应收运费":"应收运费",
                    "到付款":"到付款",
                    "代收款":"代收款",
                    "收货备注":"收货备注",
                    "出货备注":"出货备注",
                    "收件人信息":"收件人信息",
                    "选取":"选取",
                    "双击可直接选择收件人":"双击可直接选择收件人",
                    "扫描规则":"扫描规则",
                    "保存时自动打印面单":"保存时自动打印面单",
                    "自动保存收件人信息":"自动保存收件人信息",
                    "运费为":"运费为",
                    "时处理":"时处理",
                    "限制收货":"限制收货",
                    "确认提示":"确认提示",
                    "不提示不限制":"不提示不限制",
                    "提示不限制":"提示不限制",
                    "关闭":"关闭",
                    "问题件登记":"问题件登记",
                    "录单设置":"录单设置",
                    "请选择客户":"请选择客户",
                    "请选择指定路线":"请选择指定路线",
                    "请选择目的地":"请选择目的地",
                    "请输入运单号码":"请输入运单号码",
                    "请选择包装类型":"请选择包装类型",
                    "请选择货物类型":"请选择货物类型",
                    "请选择报关方式":"请选择报关方式",
                    "请输入件数":"请输入件数",
                    "请选择付款方式":"请选择付款方式",
                    "获取运单号失败!":"获取运单号失败!",
                    "请先选择客户":"请先选择客户",
                    "当前客户未设置收件人!":"当前客户未设置收件人!",
                    "中文品名不能为空":"中文品名不能为空",
                    "件数不能为空":"件数不能为空",
                    "件数必须大于等于1":"件数必须大于等于1",
                    "实重不能为空":"实重不能为空",
                    "实重必须大于0":"实重必须大于0",
                    "长不能为空":"长不能为空",
                    "长必须大于0":"长必须大于0",
                    "宽不能为空":"宽不能为空",
                    "宽必须大于0":"宽必须大于0",
                    "高不能为空":"高不能为空",
                    "高必须大于0":"高必须大于0",
                    "确定删除此行吗？":"确定删除此行吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "进入批价":"进入批价",
                    "开始批价":"开始批价",
                    "运单号为空,可能未设置单号规则":"运单号为空,可能未设置单号规则",
                    "运费为0，不允许保存":"运费为0，不允许保存",
                    "运费为0，是否继续保存？":"运费为0，是否继续保存？",
                    "运费为0！":"运费为0！",
                    "保存成功":"保存成功",
                    "运单号码<":"运单号码<",
                    ">收货中，限制修改!":">收货中，限制修改!",
                    "请先选择指定路线":"请先选择指定路线",
                    "指定路线[":"指定路线[",
                    "]成功绑定面单[":"]成功绑定面单[",
                    "9610面单":"9610面单",
                    "打印完成":"打印完成",
                    "该指定路线未设置默认面单格式":"该指定路线未设置默认面单格式",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "根据指定路线<":"根据指定路线<",
                    ">设置的邮编目的地规则，收件邮编<":">设置的邮编目的地规则，收件邮编<",
                    ">分拣的目的地为<":">分拣的目的地为<",
                    "流水号位数不够，请重新设置":"流水号位数不够，请重新设置",
                    "子单生成规则未设置，请重新设置":"子单生成规则未设置，请重新设置",
                },

            },
            "receivefast": {
                "receivefast": {
                    "客户":"客户",
                    "指定路线":"指定路线",
                    "收货包号":"收货包号",
                    "收费实重":"收费实重",
                    "自动":"自动",
                    "收费尺寸":"收费尺寸",
                    "自动保留":"自动保留",
                    "扫描单号":"扫描单号",
                    "收货设置":"收货设置",
                    "未收货订单":"未收货订单",
                    "待提交运单":"待提交运单",
                    "正常票数":"正常票数",
                    "票":"票",
                    "异常票数":"异常票数",
                    "快速收货设置":"快速收货设置",
                    "扫描单号类型":"扫描单号类型",
                    "运单号码":"运单号码",
                    "参考编号":"参考编号",
                    "转单号码":"转单号码",
                    "扫描规则":"扫描规则",
                    "保存后自动打印":"保存后自动打印",
                    "保存后自动提交":"保存后自动提交",
                    "偏远计算":"偏远计算",
                    "允许跨网点收货":"允许跨网点收货",
                    "报音":"报音",
                    "分拣码报音":"分拣码报音",
                    "限制收货报音":"限制收货报音",
                    "目的地报音":"目的地报音",
                    "异常":"异常",
                    "少重":"少重",
                    "收费重":"收费重",
                    "客户重":"客户重",
                    "超重":"超重",
                    "客户异常":"客户异常",
                    "预报客户与选择客户不符":"预报客户与选择客户不符",
                    "路线异常":"路线异常",
                    "预报指定路线与选择指定路线不符":"预报指定路线与选择指定路线不符",
                    "限制收货":"限制收货",
                    "保存":"保存",
                    "关闭":"关闭",
                    "称重设备":"称重设备",
                    "设备名称":"设备名称",
                    "设备类型":"设备类型",
                    "端口":"端口",
                    "波特率":"波特率",
                    "开始采集":"开始采集",
                    "重量采集设置":"重量采集设置",
                    "异常类型":"异常类型",
                    "件数":"件数",
                    "收费材重":"收费材重",
                    "尺寸":"尺寸",
                    "目的地":"目的地",
                    "货物类型":"货物类型",
                    "分拣码":"分拣码",
                    "收费尺寸长宽高不能为0":"收费尺寸长宽高不能为0",
                    "请输入扫描单号":"请输入扫描单号",
                    "请选择客户":"请选择客户",
                    "请选择指定路线":"请选择指定路线",
                    "请输入收货包号":"请输入收货包号",
                    "请输入收费实重":"请输入收费实重",
                    "流水号位数不够，请重新设置":"流水号位数不够，请重新设置",
                    "子单生成规则未设置，请重新设置":"子单生成规则未设置，请重新设置",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "请选择设备":"请选择设备",
                    "请填写端口":"请填写端口",
                    "请填写1-20的端口号":"请填写1-20的端口号",
                    "采集失败！":"采集失败！",
                    "电子秤":"电子秤",
                },
                "openorder": {
                    "选择收货":"选择收货",
                    "全部收货":"全部收货",
                    "选择取消":"选择取消",
                    "订单日期":"订单日期",
                    "客户":"客户",
                    "指定路线":"指定路线",
                    "订单状态":"订单状态",
                    "查询":"查询",
                    "重置":"重置",
                    "取消原因":"取消原因",
                    "注意":"注意",
                    "最多不能超过":"最多不能超过",
                    "个字符":"个字符",
                    "您选取":"您选取",
                    "待收货":"待收货",
                    "的订单共":"的订单共",
                    "笔":"笔",
                    "是否取消订单":"是否取消订单",
                    "保存":"保存",
                    "关闭":"关闭",
                    "取消订单":"取消订单",
                    "运单号码":"运单号码",
                    "参考编号":"参考编号",
                    "转单号码":"转单号码",
                    "订单编号":"订单编号",
                    "订单包号":"订单包号",
                    "寄件网点":"寄件网点",
                    "货物类型":"货物类型",
                    "目的地":"目的地",
                    "件数":"件数",
                    "客户重":"客户重",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请选择创建日期":"请选择创建日期",
                    "请选择至少一行数据":"请选择至少一行数据",
                    "请选择至少一行待收货数据":"请选择至少一行待收货数据",
                    "收货异常":"收货异常",
                    "收货成功":"收货成功",
                    "笔，已收货":"笔，已收货",
                    "笔，无预报":"笔，无预报",
                    "收货成功！":"收货成功！",
                    "已提交收货请求！":"已提交收货请求！",
                    "请选择一个客户后再进行全部收货":"请选择一个客户后再进行全部收货",
                    "未获取到对应数据":"未获取到对应数据",
                    "全部收货完成！":"全部收货完成！",
                    "取消异常":"取消异常",
                    "取消成功":"取消成功",
                    "笔，取消失败":"笔，取消失败",
                    "取消成功！":"取消成功！",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                },
                "waitwaybillsubmit": {
                    "收货提交":"收货提交",
                    "删除":"删除",
                    "寄件日期":"寄件日期",
                    "客户":"客户",
                    "指定路线":"指定路线",
                    "查询":"查询",
                    "重置":"重置",
                    "运单号码":"运单号码",
                    "参考编号":"参考编号",
                    "转单号码":"转单号码",
                    "寄件网点":"寄件网点",
                    "目的地":"目的地",
                    "包装类型":"包装类型",
                    "货物类型":"货物类型",
                    "报关方式":"报关方式",
                    "件数":"件数",
                    "收费重":"收费重",
                    "请选择寄件日期":"请选择寄件日期",
                    "请选择至少一行数据":"请选择至少一行数据",
                    "提交异常":"提交异常",
                    "提交成功":"提交成功",
                    "笔，提交失败":"笔，提交失败",
                    "提交成功！":"提交成功！",
                    "此操作将删除运单, 是否继续?":"此操作将删除运单, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择至少一个运单":"请选择至少一个运单",
                    "删除异常":"删除异常",
                    "删除成功":"删除成功",
                    "笔，删除失败":"笔，删除失败",
                    "删除成功！":"删除成功！",
                }
            },
            "bagreceive": {
                "bagreceive": {
                    "客户":"客户",
                    "指定路线":"指定路线",
                    "货物类型":"货物类型",
                    "收费实重":"收费实重",
                    "自动":"自动",
                    "收费尺寸":"收费尺寸",
                    "自动保留":"自动保留",
                    "收货包号":"收货包号",
                    "未收货包":"未收货包",
                    "收货包管理":"收货包管理",
                    "称重设备":"称重设备",
                    "设备名称":"设备名称",
                    "设备类型":"设备类型",
                    "端口":"端口",
                    "波特率":"波特率",
                    "开始采集":"开始采集",
                    "关闭":"关闭",
                    "客户名称":"客户名称",
                    "总票数":"总票数",
                    "预报实重":"预报实重",
                    "收费重":"收费重",
                    "请输入":"请输入",
                    "重量采集设置":"重量采集设置",
                    "扫描装包失败！":"扫描装包失败！",
                    "请选择设备":"请选择设备",
                    "请填写端口":"请填写端口",
                    "请填写1-20的端口号":"请填写1-20的端口号",
                    "采集失败！":"采集失败！",
                    "电子秤":"电子秤",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "客户不能为空":"客户不能为空",
                    "指定路线不能为空":"指定路线不能为空",
                    "货物类型不能为空":"货物类型不能为空",
                    "收费实重不能为空":"收费实重不能为空",
                    "收费尺寸长宽高不能为0":"收费尺寸长宽高不能为0",
                    "收货包号不能为空":"收货包号不能为空",
                    "你确定删除该预报包吗？":"你确定删除该预报包吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "预报包删除成功！":"预报包删除成功！",
                    "预报包删除失败！":"预报包删除失败！",
                    "请选择一行数据":"请选择一行数据",
                },
                "notreceivebag": {
                    "收货":"收货",
                    "取消":"取消",
                    "导出":"导出",
                    "预报日期":"预报日期",
                    "客户":"客户",
                    "指定路线":"指定路线",
                    "包状态":"包状态",
                    "查询":"查询",
                    "重置":"重置",
                    "取消原因":"取消原因",
                    "确认":"确认",
                    "关闭":"关闭",
                    "取消确认":"取消确认",
                    "预报包号":"预报包号",
                    "客户编码":"客户编码",
                    "客户名称":"客户名称",
                    "货物类型":"货物类型",
                    "总包数":"总包数",
                    "总票数":"总票数",
                    "运单重":"运单重",
                    "预报实重":"预报实重",
                    "预报材重":"预报材重",
                    "预报重":"预报重",
                    "预报体积":"预报体积",
                    "预报长宽高":"预报长宽高",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "预报日期不能为空":"预报日期不能为空",
                    "取消异常":"取消异常",
                    "取消成功！":"取消成功！",
                    "请选择至少一行数据":"请选择至少一行数据",
                    "请选择至少一行待收货数据":"请选择至少一行待收货数据",
                    "收货异常":"收货异常",
                    "收货成功！":"收货成功！",
                    "未收货查询":"未收货查询",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "提示":"提示",
                    "确定":"确定",
                },
                "receivebagmanagement": {
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "收货提交":"收货提交",
                    "撤销提交":"撤销提交",
                    "导出":"导出",
                    "收货日期":"收货日期",
                    "收货网点":"收货网点",
                    "客户":"客户",
                    "包状态":"包状态",
                    "数据来源":"数据来源",
                    "查询":"查询",
                    "重置":"重置",
                    "收货包号信息":"收货包号信息",
                    "收货包号":"收货包号",
                    "指定路线":"指定路线",
                    "货物类型":"货物类型",
                    "总包数":"总包数",
                    "总票数":"总票数",
                    "预报重":"预报重",
                    "收货重":"收货重",
                    "取件员":"取件员",
                    "备注":"备注",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "客户编码":"客户编码",
                    "客户名称":"客户名称",
                    "运单重":"运单重",
                    "预报实重":"预报实重",
                    "预报材重":"预报材重",
                    "预报尺寸":"预报尺寸",
                    "预报体积":"预报体积",
                    "收货实重":"收货实重",
                    "收货材重":"收货材重",
                    "收货尺寸":"收货尺寸",
                    "收货体积":"收货体积",
                    "预报日期":"预报日期",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请输入":"请输入",
                    "收货日期不能为空":"收货日期不能为空",
                    "确定要删除吗？":"确定要删除吗？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择一行数据":"请选择一行数据",
                    "删除收货包异常":"删除收货包异常",
                    "删除成功！":"删除成功！",
                    "收货异常":"收货异常",
                    "收货成功！":"收货成功！",
                    "确定要撤销吗？":"确定要撤销吗？",
                    "撤销提交异常":"撤销提交异常",
                    "撤销成功！":"撤销成功！",
                    "新增收货包":"新增收货包",
                    "添加异常":"添加异常",
                    "添加成功！":"添加成功！",
                    "修改异常":"修改异常",
                    "修改成功！":"修改成功！",
                    "收货包管理":"收货包管理",
                    "修改收货包":"修改收货包",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                },
            },
            "manifestquery": {
                "manifestQuery": {
                    "修改":"修改",
                    "删除":"删除",
                    "明细":"明细",
                    "专线预报导出":"专线预报导出",
                    "快速退返":"快速退返",
                    "打印":"打印",
                    "嘉里":"嘉里",
                    "标准面单":"标准面单",
                    "越南面单":"越南面单",
                    "香港面单":"香港面单",
                    "收件清单打印":"收件清单打印",
                    "导出":"导出",
                    "单号导出":"单号导出",
                    "运单号导出":"运单号导出",
                    "转单号导出":"转单号导出",
                    "导出单件信息":"导出单件信息",
                    "单件信息":"单件信息",
                    "更多条件":"更多条件",
                    "提取寄件人":"提取寄件人",
                    "标签打印":"标签打印",
                    "发票打印":"发票打印",
                    "寄件日期":"寄件日期",
                    "出货日期":"出货日期",
                    "寄件网点":"寄件网点",
                    "查录单":"查录单",
                    "客户类型":"客户类型",
                    "客户":"客户",
                    "含子客户":"含子客户",
                    "查询":"查询",
                    "重置":"重置",
                    "业务类型":"业务类型",
                    "指定路线分类":"指定路线分类",
                    "指定路线":"指定路线",
                    "包装类型":"包装类型",
                    "付款方式":"付款方式",
                    "货物类型":"货物类型",
                    "税金付款":"税金付款",
                    "销售员":"销售员",
                    "跟单员":"跟单员",
                    "有货款":"有货款",
                    "代理退件":"代理退件",
                    "目的地":"目的地",
                    "件数":"件数",
                    "走货路线分类":"走货路线分类",
                    "走货路线":"走货路线",
                    "派件网点":"派件网点",
                    "录单员":"录单员",
                    "运单状态":"运单状态",
                    "报关方式":"报关方式",
                    "运单":"运单",
                    "参考":"参考",
                    "转单":"转单",
                    "模糊":"模糊",
                    "运单信息":"运单信息",
                    "启用":"启用",
                    "保存":"保存",
                    "关闭":"关闭",
                    "代理报价信息":"代理报价信息",
                    "操作":"操作",
                    "报价名称":"报价名称",
                    "代理":"代理",
                    "渠道":"渠道",
                    "币别":"币别",
                    "备注":"备注",
                    "唯一走货路线":"唯一走货路线",
                    "有效运单":"有效运单",
                    "根据指定路线或目的地":"根据指定路线或目的地",
                    "只有唯一的一条走货路线":"只有唯一的一条走货路线",
                    "价格最优路线":"价格最优路线",
                    "在第":"在第",
                    "点的基础上":"点的基础上",
                    "如有多条走货路线时":"如有多条走货路线时",
                    "价格最优的走货路线为价格最优路线":"价格最优的走货路线为价格最优路线",
                    "如价格计算为":"如价格计算为",
                    "除外":"除外",
                    "重量优先路线":"重量优先路线",
                    "当包装类型为":"当包装类型为",
                    "并且在收货时有录入单件信息时":"并且在收货时有录入单件信息时",
                    "如果走货路线的材积除以数":"如果走货路线的材积除以数",
                    "与指定路线的材积除以数不相同时":"与指定路线的材积除以数不相同时",
                    "将重新计算出货重":"将重新计算出货重",
                    "如果此走货路线为价格最优的路线":"如果此走货路线为价格最优的路线",
                    "为重":"为重",
                    "量最优路线":"量最优路线",
                    "无有效价格":"无有效价格",
                    "无效运单":"无效运单",
                    "如多条走货路线计算价格都为":"如多条走货路线计算价格都为",
                    "为无有效价格":"为无有效价格",
                    "无走货路线":"无走货路线",
                    "没有对应的走货路线":"没有对应的走货路线",
                    "为无走货路线":"为无走货路线",
                    "是":"是",
                    "否":"否",
                    "按单号导出":"按单号导出",
                    "取消":"取消",
                    "退返方式":"退返方式",
                    "退返单号":"退返单号",
                    "退返备注":"退返备注",
                    "您选取了":"您选取了",
                    "笔记录数据":"笔记录数据",
                    "其中可退返":"其中可退返",
                    "笔":"笔",
                    "确定":"确定",
                    "新增运单":"新增运单",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "运单号(不能重复)*":"运单号(不能重复)*",
                    "国内仓库":"国内仓库",
                    "转单号":"转单号",
                    "分货标签":"分货标签",
                    "收件日期*":"收件日期*",
                    "客户(全称或者代号)*":"客户(全称或者代号)*",
                    "客户(客户全称或者代号)*":"客户(客户全称或者代号)*",
                    "走货渠道":"走货渠道",
                    "价格渠道":"价格渠道",
                    "货物性质(带磁/带电/纺织品等)*":"货物性质(带磁/带电/纺织品等)*",
                    "清关方式":"清关方式",
                    "地址类型/亚马逊/商业地址*":"地址类型/亚马逊/商业地址*",
                    "卡车预约号/ReferenceID":"卡车预约号/ReferenceID",
                    "收货人邮编*":"收货人邮编*",
                    "收件人国家代码(二字代码)*":"收件人国家代码(二字代码)*",
                    "收货人公司名":"收货人公司名",
                    "收货人姓名":"收货人姓名",
                    "省份/州":"省份/州",
                    "收货城市":"收货城市",
                    "收货地址1":"收货地址1",
                    "收货地址2":"收货地址2",
                    "收货人电话":"收货人电话",
                    "收货人邮箱":"收货人邮箱",
                    "其他地址/门牌":"其他地址/门牌",
                    "起运地":"起运地",
                    "预付/到付":"预付/到付",
                    "代收币种":"代收币种",
                    "代收金额":"代收金额",
                    "外部备注":"外部备注",
                    "VAT号":"VAT号",
                    "EORI号":"EORI号",
                    "VAT公司名":"VAT公司名",
                    "VAT地址":"VAT地址",
                    "是否购买保险":"是否购买保险",
                    "总件数*":"总件数*",
                    "分件数*":"分件数*",
                    "行号*":"行号*",
                    "单件实重":"单件实重",
                    "长":"长",
                    "宽":"宽",
                    "高":"高",
                    "FBA子单号/箱唛号*":"FBA子单号/箱唛号*",
                    "中文品名*":"中文品名*",
                    "英文品名*":"英文品名*",
                    "产品品牌":"产品品牌",
                    "产品海关编码*":"产品海关编码*",
                    "单件产品申报数量*":"单件产品申报数量*",
                    "单个产品申报单价*":"单个产品申报单价*",
                    "单个产品净重*":"单个产品净重*",
                    "采购单价(RMB)":"采购单价(RMB)",
                    "Sku码":"Sku码",
                    "型号":"型号",
                    "材质":"材质",
                    "用途":"用途",
                    "包装":"包装",
                    "产品下载/产品库链接":"产品下载/产品库链接",
                    "产品销售链接":"产品销售链接",
                    "错误":"错误",
                    "导入出错提示":"导入出错提示",
                    "系统单号":"系统单号",
                    "国外海关编码":"国外海关编码",
                    "请选择要打印订单的数据":"请选择要打印订单的数据",
                    "异常":"异常",
                    "请选择运单":"请选择运单",
                    "请选择至少一行数据":"请选择至少一行数据",
                    "提取成功":"提取成功",
                    "运单号码":"运单号码",
                    "参考编号":"参考编号",
                    "转单号码":"转单号码",
                    "实重":"实重",
                    "除以数":"除以数",
                    "材重":"材重",
                    "收费重量":"收费重量",
                    "体积":"体积",
                    "包装项目":"包装项目",
                    "包装费":"包装费",
                    "包装说明":"包装说明",
                    "包号/板号":"包号/板号",
                    "录单网点":"录单网点",
                    "客户编码":"客户编码",
                    "客户名称":"客户名称",
                    "寄件人":"寄件人",
                    "寄件电话":"寄件电话",
                    "寄件邮箱":"寄件邮箱",
                    "收件人":"收件人",
                    "收件电话":"收件电话",
                    "收件邮编":"收件邮编",
                    "收件城市":"收件城市",
                    "收件地址":"收件地址",
                    "目的地编码":"目的地编码",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "代收款":"代收款",
                    "代收币别":"代收币别",
                    "预报重":"预报重",
                    "收费实重":"收费实重",
                    "收费材重":"收费材重",
                    "收费体积":"收费体积",
                    "收费重":"收费重",
                    "申报价值":"申报价值",
                    "申报价值币别":"申报价值币别",
                    "问题件":"问题件",
                    "问题最新描述":"问题最新描述",
                    "退返客户":"退返客户",
                    "出货重":"出货重",
                    "上板":"上板",
                    "机场代码":"机场代码",
                    "走货路线名":"走货路线名",
                    "寄件账号":"寄件账号",
                    "总运单号":"总运单号",
                    "交接单号":"交接单号",
                    "收件备注":"收件备注",
                    "出货备注":"出货备注",
                    "最新轨迹状态":"最新轨迹状态",
                    "最新轨迹网点":"最新轨迹网点",
                    "是否偏远":"是否偏远",
                    "数据来源":"数据来源",
                    "港前客服":"港前客服",
                    "港后客服":"港后客服",
                    "应收运费":"应收运费",
                    "请输入单号！":"请输入单号！",
                    "请选择运单！":"请选择运单！",
                    "退返客户失败！":"退返客户失败！",
                    "退返客户成功！":"退返客户成功！",
                    "寄件日期不能为空":"寄件日期不能为空",
                    "已出货，不允许删除！":"已出货，不允许删除！",
                    "确定要删除<":"确定要删除<",
                    ">吗？":">吗？",
                    "提示":"提示",
                    "请选择一行数据":"请选择一行数据",
                    "退返方式等于{第三方快递}时，退返单号必填":"退返方式等于{第三方快递}时，退返单号必填",
                    "操作成功":"操作成功",
                    "删除运单异常":"删除运单异常",
                    "删除成功！":"删除成功！",
                    "自动运单异常":"自动运单异常",
                    "自动运单成功！":"自动运单成功！",
                    "修改异常":"修改异常",
                    "修改成功！":"修改成功！",
                    "添加异常":"添加异常",
                    "添加成功！":"添加成功！",
                    "运单查询":"运单查询",
                    "运单导出":"运单导出",
                    "创建导出任务，请稍后在导出列表中下载！":"创建导出任务，请稍后在导出列表中下载！",
                    "每行高亮":"每行高亮",
                    "背景色设置":"背景色设置",
                    "展开开关":"展开开关",
                    "请选择需要打印的数据":"请选择需要打印的数据",
                    "9610面单":"9610面单",
                    "打印完成":"打印完成",
                    "勾选的多条运单的客户必须是同一个才可打印！":"勾选的多条运单的客户必须是同一个才可打印！",
                    "流水号位数不够，请重新设置":"流水号位数不够，请重新设置",
                    "子单生成规则未设置，请重新设置":"子单生成规则未设置，请重新设置",
                },
                "manifestmodify": {
                    "运单":"运单",
                    "运单号码":"运单号码",
                    "转单号码":"转单号码",
                    "参考编号":"参考编号",
                    "客户":"客户",
                    "指定路线":"指定路线",
                    "货物信息":"货物信息",
                    "报关方式":"报关方式",
                    "包装类型":"包装类型",
                    "货物类型":"货物类型",
                    "件数":"件数",
                    "收费实重":"收费实重",
                    "收费材重":"收费材重",
                    "收费重":"收费重",
                    "出货实重":"出货实重",
                    "出货材重":"出货材重",
                    "出货重":"出货重",
                    "申报价值":"申报价值",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "数量":"数量",
                    "收货备注":"收货备注",
                    "出货备注":"出货备注",
                    "寄件人":"寄件人",
                    "寄件公司":"寄件公司",
                    "寄件电话":"寄件电话",
                    "寄件地址":"寄件地址",
                    "寄件国家":"寄件国家",
                    "寄件州":"寄件州",
                    "省":"省",
                    "寄件城市":"寄件城市",
                    "寄件邮编":"寄件邮编",
                    "寄件网点":"寄件网点",
                    "寄件日期":"寄件日期",
                    "取件员":"取件员",
                    "目的地":"目的地",
                    "走货路线":"走货路线",
                    "派件网点":"派件网点",
                    "费用结算":"费用结算",
                    "付款方式":"付款方式",
                    "到付款":"到付款",
                    "税金付款":"税金付款",
                    "代收款":"代收款",
                    "其他科目":"其他科目",
                    "金额":"金额",
                    "币别":"币别",
                    "结算备注":"结算备注",
                    "收件人":"收件人",
                    "收件公司":"收件公司",
                    "收件电话":"收件电话",
                    "收件地址":"收件地址",
                    "收件税号":"收件税号",
                    "收件国家":"收件国家",
                    "收件州":"收件州",
                    "收件城市":"收件城市",
                    "收件邮编":"收件邮编",
                    "信息":"信息",
                    "显示":"显示",
                    "序号":"序号",
                    "操作":"操作",
                    "删除":"删除",
                    "单价":"单价",
                    "总价":"总价",
                    "海关编码":"海关编码",
                    "净重":"净重",
                    "毛重":"毛重",
                    "原产地":"原产地",
                    "备注":"备注",
                    "单件信息":"单件信息",
                    "运单信息":"运单信息",
                    "注意":"注意",
                    "以下录入的都为单件信息":"以下录入的都为单件信息",
                    "单件进位规则":"单件进位规则",
                    "单票计抛规则":"单票计抛规则",
                    "修改":"修改",
                    "单票进位规则":"单票进位规则",
                    "新增":"新增",
                    "实重":"实重",
                    "长":"长",
                    "宽":"宽",
                    "高":"高",
                    "除以数":"除以数",
                    "材重":"材重",
                    "最小重量":"最小重量",
                    "生效类型":"生效类型",
                    "包装项目":"包装项目",
                    "包装费":"包装费",
                    "包装说明":"包装说明",
                    "保存":"保存",
                    "同步复制实重":"同步复制实重",
                    "尺寸复制":"尺寸复制",
                    "全部清除":"全部清除",
                    "全部删除":"全部删除",
                    "导出":"导出",
                    "请输入运单号码":"请输入运单号码",
                    "请选择寄件网点":"请选择寄件网点",
                    "请选择寄件日期":"请选择寄件日期",
                    "请选择客户":"请选择客户",
                    "请选择指定路线":"请选择指定路线",
                    "请选择目的地":"请选择目的地",
                    "请选择报关方式":"请选择报关方式",
                    "请选择货物类型":"请选择货物类型",
                    "请选择包装类型":"请选择包装类型",
                    "请输入件数":"请输入件数",
                    "请输入收费实重":"请输入收费实重",
                    "请输入出货实重":"请输入出货实重",
                    "请选择付款方式":"请选择付款方式",
                    "保存&S":"保存&S",
                    "根据指定路线<":"根据指定路线<",
                    ">设置的邮编目的地规则，收件邮编<":">设置的邮编目的地规则，收件邮编<",
                    ">分拣的目的地为<":">分拣的目的地为<",
                    "提示":"提示",
                    "偏远":"偏远",
                    ",偏远,":",偏远,",
                    "偏远,":"偏远,",
                    ",偏远":",偏远",
                    "运单号码<":"运单号码<",
                    ">收货中，限制修改!":">收货中，限制修改!",
                    "未找到对应运单，请重新填写":"未找到对应运单，请重新填写",
                    "修改成功，运单<":"修改成功，运单<",
                    ">已出货，指定路线、目的地、件数、包装类型、收费重修改后可能影响到港后，请通知港后客服！":">已出货，指定路线、目的地、件数、包装类型、收费重修改后可能影响到港后，请通知港后客服！",
                    "收费重为0，不允许保存":"收费重为0，不允许保存",
                    "请选择到付币别!":"请选择到付币别!",
                    "请选择代收币别!":"请选择代收币别!",
                    "修改成功！":"修改成功！",
                    "追踪进行中，请稍候查询":"追踪进行中，请稍候查询",
                    "物流助手初始化失败,请稍后重试":"物流助手初始化失败,请稍后重试",
                    "助手返回任务id失败":"助手返回任务id失败",
                    "追踪结束":"追踪结束",
                    "已加入自动追踪任务":"已加入自动追踪任务",
                    "--请求轨迹原数据失败--":"--请求轨迹原数据失败--",
                    "当前指定路线的计抛方式发生变化，收费重由<":"当前指定路线的计抛方式发生变化，收费重由<",
                    ">变为<":">变为<",
                    "当前指定路线的计抛方式发生变化，请重新保存单件信息":"当前指定路线的计抛方式发生变化，请重新保存单件信息",
                    "当前指定路线的材积除以数由<":"当前指定路线的材积除以数由<",
                    ">改为<":">改为<",
                    ">，请重新保存单件信息":">，请重新保存单件信息",
                    "当前指定路线为空改为<":"当前指定路线为空改为<",
                    "单件取大不计抛":"单件取大不计抛",
                    "请选择指定路线!":"请选择指定路线!",
                    "录入件数为":"录入件数为",
                    "件，而单件数为":"件，而单件数为",
                    "件，是否清除多余的件数":"件，是否清除多余的件数",
                    "确定":"确定",
                    "取消":"取消",
                    "实重材重同时为0，不允许保存和关闭":"实重材重同时为0，不允许保存和关闭",
                    "存在为0数据,不允许保存和关闭":"存在为0数据,不允许保存和关闭",
                    "存在为空数据,不允许保存和关闭":"存在为空数据,不允许保存和关闭",
                    "{附加项目:":"{附加项目:",
                    "存在不收件，请重新填写标红件！":"存在不收件，请重新填写标红件！",
                    "单件信息件数与运单件数不一致，是否继续保存":"单件信息件数与运单件数不一致，是否继续保存",
                    "请选择需要删除的单件信息!":"请选择需要删除的单件信息!",
                    "确认删除当前单件信息？":"确认删除当前单件信息？",
                    "确定删除当前所有单件信息？":"确定删除当前所有单件信息？",
                    "确定删除此行吗？":"确定删除此行吗？",
                    "英文品名不能为空":"英文品名不能为空",
                    "净重必须大于等于0":"净重必须大于等于0",
                    "毛重必须大于等于0":"毛重必须大于等于0",
                },
                "stockinprequery":{
                    "导出":"导出",
                    "入库预查":"入库预查",
                    "更多条件":"更多条件",
                    "入库时间":"入库时间",
                    "库存网点":"库存网点",
                    "客户":"客户",
                    "排仓分区":"排仓分区",
                    "指定路线分类":"指定路线分类",
                    "可多选":"可多选",
                    "走货路线":"走货路线",
                    "目的地":"目的地",
                    "最新状态网点":"最新状态网点",
                    "销售员":"销售员",
                    "跟单员":"跟单员",
                    "查询":"查询",
                    "重置":"重置",
                    "走货路线分类":"走货路线分类",
                    "录单网点":"录单网点",
                    "货物类型":"货物类型",
                    "报关方式":"报关方式",
                    "收费重":"收费重",
                    "全部":"全部",
                    "未出货":"未出货",
                    "待转单":"待转单",
                    "待交接":"待交接",
                    "待上板":"待上板",
                    "已上板":"已上板",
                    "预报":"预报",
                    "问题件":"问题件",
                    "已退返":"已退返",
                    "漏出货":"漏出货",
                    "欠费锁机":"欠费锁机",
                    "有库存":"有库存",
                    "状态":"状态",
                    "客户编码":"客户编码",
                    "客户名称":"客户名称",
                    "运单号码":"运单号码",
                    "转单号码":"转单号码",
                    "参考编号":"参考编号",
                    "总运单号":"总运单号",
                    "交接单号":"交接单号",
                    "板号":"板号",
                    "指定路线":"指定路线",
                    "目的地编码":"目的地编码",
                    "排仓分区名称":"排仓分区名称",
                    "收件邮编":"收件邮编",
                    "收件城市":"收件城市",
                    "机场代码":"机场代码",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "申报价值":"申报价值",
                    "申报价值币别":"申报价值币别",
                    "运单件数":"运单件数",
                    "库存件数":"库存件数",
                    "收费实重":"收费实重",
                    "收费材重":"收费材重",
                    "出货重":"出货重",
                    "预报重":"预报重",
                    "包装类型":"包装类型",
                    "付款方式":"付款方式",
                    "税金付款":"税金付款",
                    "收件备注":"收件备注",
                    "港前问题件":"港前问题件",
                    "问题描述":"问题描述",
                    "最新轨迹状态":"最新轨迹状态",
                    "最新轨迹网点":"最新轨迹网点",
                    "最新轨迹时间":"最新轨迹时间",
                    "寄件人公司":"寄件人公司",
                    "寄件人":"寄件人",
                    "寄件电话":"寄件电话",
                    "寄件邮箱":"寄件邮箱",
                    "收件公司":"收件公司",
                    "收件人":"收件人",
                    "收件地址":"收件地址",
                    "入库时间不能为空":"入库时间不能为空",
                    "库存网点不能为空":"库存网点不能为空",
                    "&nbsp;&nbsp;票数:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;票数:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;运单件数:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;运单件数:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;库存件数:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;库存件数:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;收费实重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;收费实重:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;收费材重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;收费材重:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;收费重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;收费重:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;出货重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;出货重:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;预报重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;预报重:&nbsp;&nbsp;<span style=color: red>",
                },
                "manifestQuery2":{
                    "导出":"导出",
                    "更多条件":"更多条件",
                    "寄件日期":"寄件日期",
                    "寄件网点":"寄件网点",
                    "录单网点":"录单网点",
                    "库存网点":"库存网点",
                    "客户":"客户",
                    "指定路线":"指定路线",
                    "可多选":"可多选",
                    "走货路线":"走货路线",
                    "目的地":"目的地",
                    "最新轨迹网点":"最新轨迹网点",
                    "查询":"查询",
                    "重置":"重置",
                    "指定路线分类":"指定路线分类",
                    "走货路线分类":"走货路线分类",
                    "排仓分区":"排仓分区",
                    "货物类型":"货物类型",
                    "报关方式":"报关方式",
                    "销售员":"销售员",
                    "跟单员":"跟单员",
                    "收费重":"收费重",
                    "全部":"全部",
                    "未出货":"未出货",
                    "待转单":"待转单",
                    "待交接":"待交接",
                    "待上板":"待上板",
                    "已上板":"已上板",
                    "问题件":"问题件",
                    "已退返":"已退返",
                    "漏出货":"漏出货",
                    "欠费锁机":"欠费锁机",
                    "已出货":"已出货",
                    "未提取":"未提取",
                    "已提取":"已提取",
                    "运输中":"运输中",
                    "已签收":"已签收",
                    "代理退件":"代理退件",
                    "清关延误":"清关延误",
                    "派送异常":"派送异常",
                    "国外退件":"国外退件",
                    "状态":"状态",
                    "客户编码":"客户编码",
                    "客户名称":"客户名称",
                    "运单号码":"运单号码",
                    "转单号码":"转单号码",
                    "参考编号":"参考编号",
                    "总运单号":"总运单号",
                    "交接单号":"交接单号",
                    "板号":"板号",
                    "目的地编码":"目的地编码",
                    "排仓分区名称":"排仓分区名称",
                    "收件邮编":"收件邮编",
                    "收件城市":"收件城市",
                    "机场代码":"机场代码",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "申报价值":"申报价值",
                    "申报价值币别":"申报价值币别",
                    "件数":"件数",
                    "收费实重":"收费实重",
                    "收费材重":"收费材重",
                    "收费体积":"收费体积",
                    "出货重":"出货重",
                    "预报重":"预报重",
                    "包装类型":"包装类型",
                    "付款方式":"付款方式",
                    "税金付款":"税金付款",
                    "收件备注":"收件备注",
                    "港前问题件":"港前问题件",
                    "问题描述":"问题描述",
                    "代理取件时间":"代理取件时间",
                    "最新轨迹状态":"最新轨迹状态",
                    "最新轨迹时间":"最新轨迹时间",
                    "寄件人公司":"寄件人公司",
                    "寄件人":"寄件人",
                    "寄件电话":"寄件电话",
                    "寄件邮箱":"寄件邮箱",
                    "收件公司":"收件公司",
                    "收件人":"收件人",
                    "收件地址":"收件地址",
                    "港前客服":"港前客服",
                    "港后客服":"港后客服",
                    "应收运费":"应收运费",
                    "派件网点":"派件网点",
                    "寄件日期不能为空":"寄件日期不能为空",
                    "&nbsp;&nbsp;票数:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;票数:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;件数:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;件数:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;收费实重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;收费实重:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;收费材重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;收费材重:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;收费重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;收费重:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;出货重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;出货重:&nbsp;&nbsp;<span style=color: red>",
                    "&nbsp;&nbsp;预报重:&nbsp;&nbsp;<span style=color: red>":"&nbsp;&nbsp;预报重:&nbsp;&nbsp;<span style=color: red>",
                    "每行高亮":"每行高亮",
                    "背景色设置":"背景色设置",
                },
                "invoiceQuery":{
                    "导入修改":"导入修改",
                    "导出":"导出",
                    "查询":"查询",
                    "寄件日期":"寄件日期",
                    "寄件网点":"寄件网点",
                    "指定路线分类":"指定路线分类",
                    "可多选":"可多选",
                    "指定路线":"指定路线",
                    "重置":"重置",
                    "走货路线分类":"走货路线分类",
                    "走货路线":"走货路线",
                    "目的地":"目的地",
                    "货物类型":"货物类型",
                    "报关方式":"报关方式",
                    "运单状态":"运单状态",
                    "单号":"单号",
                    "清关包号":"清关包号",
                    "运单号码":"运单号码",
                    "参考编号":"参考编号",
                    "转单号码":"转单号码",
                    "Invoice信息":"Invoice信息",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "数量":"数量",
                    "单价":"单价",
                    "总价":"总价",
                    "海关编码":"海关编码",
                    "材质":"材质",
                    "用途":"用途",
                    "收件信息":"收件信息",
                    "收件税号":"收件税号",
                    "收件人":"收件人",
                    "收件公司":"收件公司",
                    "收件电话":"收件电话",
                    "收件地址":"收件地址",
                    "收件地址2":"收件地址2",
                    "收件地址3":"收件地址3",
                    "收件国家":"收件国家",
                    "收件州/省":"收件州/省",
                    "收件城市":"收件城市",
                    "收件邮编":"收件邮编",
                    "运单信息":"运单信息",
                    "目的地编码":"目的地编码",
                    "包装类型":"包装类型",
                    "件数":"件数",
                    "收费实重":"收费实重",
                    "收费材重":"收费材重",
                    "收费重":"收费重",
                    "派件网点":"派件网点",
                    "客户编码":"客户编码",
                    "客户名称":"客户名称",
                    "寄件日期不能为空":"寄件日期不能为空",
                    "Invoice查询":"Invoice查询",
                    "每行高亮":"每行高亮",
                    "背景色设置":"背景色设置",
                },
            },
            "manifestchangeaudit":{
                "manifestchangeaudit":{
                    "批量审核":"批量审核",
                    "全部审核":"全部审核",
                    "取消变更":"取消变更",
                    "导出":"导出",
                    "申请变更时间":"申请变更时间",
                    "寄件网点":"寄件网点",
                    "查录单":"查录单",
                    "变更来源":"变更来源",
                    "客户":"客户",
                    "对账员":"对账员",
                    "变更状态":"变更状态",
                    "查询":"查询",
                    "重置":"重置",
                    "自动审核":"自动审核",
                    "运单号码":"运单号码",
                    "转单号码":"转单号码",
                    "参考编号":"参考编号",
                    "寄件日期":"寄件日期",
                    "&寄件日期":"&寄件日期",
                    "&寄件网点":"&寄件网点",
                    "&客户编码":"&客户编码",
                    "&指定路线":"&指定路线",
                    "&目的地":"&目的地",
                    "&包装类型":"&包装类型",
                    "&收费实重":"&收费实重",
                    "&收费材重":"&收费材重",
                    "&计抛规则":"&计抛规则",
                    "&收费重":"&收费重",
                    "其他费用":"其他费用",
                    "&出货重":"&出货重",
                    "&走货路线":"&走货路线",
                    "&派件网点":"&派件网点",
                    "&付款方式":"&付款方式",
                    "&费用合计":"&费用合计",
                    "&合计币别":"&合计币别",
                    "&到付款":"&到付款",
                    "&到付币别":"&到付币别",
                    "&报关方式":"&报关方式",
                    "&货物类型":"&货物类型",
                    "申请人":"申请人",
                    "审核人":"审核人",
                    "审核时间":"审核时间",
                    "请选择申请变更时间":"请选择申请变更时间",
                    "全部审核成功！":"全部审核成功！",
                    "请选择至少一行数据":"请选择至少一行数据",
                    "请选择至少一行待审核数据":"请选择至少一行待审核数据",
                    "审核失败！":"审核失败！",
                    "审核成功！":"审核成功！",
                    "状态不为待审核，无法取消！":"状态不为待审核，无法取消！",
                    "确定取消运单<":"确定取消运单<",
                    ">的变更申请？":">的变更申请？",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "请选择变更记录":"请选择变更记录",
                    "取消审核失败！":"取消审核失败！",
                    "取消审核成功！":"取消审核成功！",
                }
            },
            "barcodeprinting":{
                "barcodeprinting":{
                    "打印":"打印",
                    "打印设置":"打印设置",
                    "扫描单号":"扫描单号",
                    "件数":"件数",
                    "份数":"份数",
                    "起始件数":"起始件数",
                    "终止件数":"终止件数",
                    "打印选项":"打印选项",
                    "收货标签":"收货标签",
                    "发票标签":"发票标签",
                    "运单标签":"运单标签",
                    "设置":"设置",
                    "验证录单":"验证录单",
                    "验证预报":"验证预报",
                    "单票打印":"单票打印",
                    "打印全部件数":"打印全部件数",
                    "请输入件数":"请输入件数",
                    "请输入份数":"请输入份数",
                    "请输入单号":"请输入单号",
                    "请输入运单号码":"请输入运单号码",
                    "起始件数不能小于终止件数":"起始件数不能小于终止件数",
                    "子单号码固定位":"子单号码固定位",
                    "子单号码流水号位数":"子单号码流水号位数",
                    "流水号位数不够，请重新设置":"流水号位数不够，请重新设置",
                    "子单生成规则未设置，请重新设置":"子单生成规则未设置，请重新设置",
                    "运单已经被使用，请检查":"运单已经被使用，请检查",
                    "件数不能超过可打印件数":"件数不能超过可打印件数",
                    "错误打印:":"错误打印:",
                    "超出最大打印件数,需由运单标签打印:":"超出最大打印件数,需由运单标签打印:",
                    "打印完成":"打印完成",
                }
            },
            "checkgoods":{
                "checkgoods":{
                    "扫描单号":"扫描单号",
                    "运单信息":"运单信息",
                    "运单号码":"运单号码",
                    "参考编号":"参考编号",
                    "指定路线":"指定路线",
                    "目的地信息":"目的地信息",
                    "货物类型":"货物类型",
                    "报关方式":"报关方式",
                    "包装类型":"包装类型",
                    "客户":"客户",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "件数":"件数",
                    "数量":"数量",
                    "收费实重":"收费实重",
                    "收费材重":"收费材重",
                    "收费重":"收费重",
                    "收件备注":"收件备注",
                    "查货状态":"查货状态",
                    "正常件":"正常件",
                    "提交":"提交",
                    "序号":"序号",
                    "操作":"操作",
                    "删除":"删除",
                    "问题状态":"问题状态",
                    "问题描述":"问题描述",
                    "选择查货问题状态":"选择查货问题状态",
                    "输入编码或名称后立即查询":"输入编码或名称后立即查询",
                    "问题编码":"问题编码",
                    "问题名称":"问题名称",
                    "选取":"选取",
                    "关闭":"关闭",
                    "其它问题":"其它问题",
                    "请输入":"请输入",
                    "删除成功！":"删除成功！",
                    "删除失败！":"删除失败！",
                    "提交成功！":"提交成功！",
                    "提交失败1！":"提交失败1！",
                    "无运单数据，请确认后再提交！":"无运单数据，请确认后再提交！",
                    "扫描单号不能为空！":"扫描单号不能为空！",
                    "无运单信息，无法打开其他问题！":"无运单信息，无法打开其他问题！",
                    "请先选择一个问题状态":"请先选择一个问题状态",
                    "可在此输入问题描述。扫描下一笔运单,自动保存上-笔运单的查货信息。CTRL+S可以直接保存当前查货记录":"可在此输入问题描述。扫描下一笔运单,自动保存上-笔运单的查货信息。CTRL+S可以直接保存当前查货记录",
                }
            },
            "goodsallocpod":{
                "goodsallocpod":{
                    "货位编码":"货位编码",
                    "扫描单号":"扫描单号",
                    "选取运单":"选取运单",
                    "扫描票数":"扫描票数",
                    "票":"票",
                    "选择货位":"选择货位",
                    "货位类型":"货位类型",
                    "查询":"查询",
                    "重置":"重置",
                    "忽略已上架":"忽略已上架",
                    "入库时间":"入库时间",
                    "路线大类":"路线大类",
                    "指定路线分类":"指定路线分类",
                    "指定路线":"指定路线",
                    "可多选":"可多选",
                    "客户":"客户",
                    "含子客户":"含子客户",
                    "操作员":"操作员",
                    "只显示本人":"只显示本人",
                    "选择运单":"选择运单",
                    "运单号码":"运单号码",
                    "转单号码":"转单号码",
                    "参考编号":"参考编号",
                    "货位编号":"货位编号",
                    "目的地":"目的地",
                    "寄件时间":"寄件时间",
                    "报关类型":"报关类型",
                    "货物类型":"货物类型",
                    "件数":"件数",
                    "扫描时间":"扫描时间",
                    "收费重":"收费重",
                    "收件备注":"收件备注",
                    "问题件":"问题件",
                    "最新问题描述":"最新问题描述",
                    "备注":"备注",
                    "请选中一条数据":"请选中一条数据",
                    "请选择货位":"请选择货位",
                    "扫描单号不能为空":"扫描单号不能为空",
                    "上架成功":"上架成功",
                    "请选择运单":"请选择运单",
                }
            },
            "fdorder":{
                "fdorder":{
                    "保存":"保存",
                    "保存并审单":"保存并审单",
                    "保存并打印面单":"保存并打印面单",
                    "设置":"设置",
                    "运单号码":"运单号码",
                    "转单号码":"转单号码",
                    "参考号码":"参考号码",
                    "渠道":"渠道",
                    "寄件信息":"寄件信息",
                    "选择":"选择",
                    "保存寄件信息":"保存寄件信息",
                    "指定路线":"指定路线",
                    "目的地":"目的地",
                    "客户":"客户",
                    "寄件公司":"寄件公司",
                    "寄件人":"寄件人",
                    "寄件电话":"寄件电话",
                    "寄件地址":"寄件地址",
                    "货物信息":"货物信息",
                    "包装类型":"包装类型",
                    "报关方式":"报关方式",
                    "货物类型":"货物类型",
                    "件数":"件数",
                    "收费实重":"收费实重",
                    "收费材重":"收费材重",
                    "收费重":"收费重",
                    "申报价值":"申报价值",
                    "中文品名":"中文品名",
                    "英文品名":"英文品名",
                    "数量":"数量",
                    "收件备注":"收件备注",
                    "选填":"选填",
                    "字符以内":"字符以内",
                    "取件员":"取件员",
                    "寄件网点":"寄件网点",
                    "寄件日期":"寄件日期",
                    "收件信息":"收件信息",
                    "保存收件信息":"保存收件信息",
                    "收件电话":"收件电话",
                    "必填":"必填",
                    "收件公司":"收件公司",
                    "收件地址":"收件地址",
                    "收件人":"收件人",
                    "收件税号":"收件税号",
                    "收件邮编":"收件邮编",
                    "收件州":"收件州",
                    "省":"省",
                    "收件城市":"收件城市",
                    "收件国家":"收件国家",
                    "结算信息":"结算信息",
                    "付款方式":"付款方式",
                    "到付款":"到付款",
                    "付款客户":"付款客户",
                    "客户代号":"客户代号",
                    "代收款":"代收款",
                    "科目":"科目",
                    "金额":"金额",
                    "税金付款":"税金付款",
                    "结算备注":"结算备注",
                    "信息":"信息",
                    "导入":"导入",
                    "显示":"显示",
                    "序号":"序号",
                    "操作":"操作",
                    "添加":"添加",
                    "删除":"删除",
                    "单价":"单价",
                    "总价":"总价",
                    "单个重量":"单个重量",
                    "海关编码":"海关编码",
                    "更多信息":"更多信息",
                    "点击保存按钮后添加信息":"点击保存按钮后添加信息",
                    "配货信息":"配货信息",
                    "商品图片地址":"商品图片地址",
                    "商品链接地址":"商品链接地址",
                    "材质":"材质",
                    "用途":"用途",
                    "规格":"规格",
                    "行邮税号":"行邮税号",
                    "品牌":"品牌",
                    "原产地":"原产地",
                    "确定":"确定",
                    "清空":"清空",
                    "上传附件":"上传附件",
                    "导入格式":"导入格式",
                    "行":"行",
                    "列":"列",
                    "导入前请将":"导入前请将",
                    "信息复制到剪贴板即可":"信息复制到剪贴板即可",
                    "注意以下几点要求":"注意以下几点要求",
                    "格式为":"格式为",
                    "列与列直接用":"列与列直接用",
                    "隔开":"隔开",
                    "关闭":"关闭",
                    "请输入内容":"请输入内容",
                    "其他":"其他",
                    "选取":"选取",
                    "扫描规则":"扫描规则",
                    "允许跨网点收货":"允许跨网点收货",
                    "保留上一票信息":"保留上一票信息",
                    "子单生成规则":"子单生成规则",
                    "固定位":"固定位",
                    "流水号位数":"流水号位数",
                    "最大打印件数":"最大打印件数",
                    "输入任意内容可检索":"输入任意内容可检索",
                    "运单信息":"运单信息",
                    "注意":"注意",
                    "以下录入的都为单件信息":"以下录入的都为单件信息",
                    "单件进位规则":"单件进位规则",
                    "单票计抛规则":"单票计抛规则",
                    "修改":"修改",
                    "单票进位规则":"单票进位规则",
                    "单件信息":"单件信息",
                    "新增":"新增",
                    "实重":"实重",
                    "长":"长",
                    "宽":"宽",
                    "高":"高",
                    "除以数":"除以数",
                    "材重":"材重",
                    "最小重量":"最小重量",
                    "生效类型":"生效类型",
                    "包装项目":"包装项目",
                    "包装费":"包装费",
                    "币别":"币别",
                    "包装说明":"包装说明",
                    "子单号码":"子单号码",
                    "同步复制实重":"同步复制实重",
                    "尺寸复制":"尺寸复制",
                    "全部清除":"全部清除",
                    "全部删除":"全部删除",
                    "导出":"导出",
                    "选择寄件信息":"选择寄件信息",
                    "录单设置":"录单设置",
                    "选择常用收件人":"选择常用收件人",
                    "INVOICE导入":"INVOICE导入",
                    "运费":"运费",
                    "燃油费":"燃油费",
                    "报关费":"报关费",
                    "产证费":"产证费",
                    "保险费":"保险费",
                    "其他费":"其他费",
                    "请输入运单号码":"请输入运单号码",
                    "请选择取件员":"请选择取件员",
                    "请选择寄件网点":"请选择寄件网点",
                    "请选择寄件日期":"请选择寄件日期",
                    "请输入指定路线":"请输入指定路线",
                    "请输入目的地":"请输入目的地",
                    "请输入客户":"请输入客户",
                    "请输入收件电话":"请输入收件电话",
                    "请输入收件地址":"请输入收件地址",
                    "请输入收件人":"请输入收件人",
                    "请选择包装类型":"请选择包装类型",
                    "请选择报关方式":"请选择报关方式",
                    "请选择货物类型":"请选择货物类型",
                    "请输入件数":"请输入件数",
                    "请输入收费实重":"请输入收费实重",
                    "请选择付款方式":"请选择付款方式",
                    "运单收货中，请通知录单员提交后在重新录入！":"运单收货中，请通知录单员提交后在重新录入！",
                    "已审单，不允许补录！":"已审单，不允许补录！",
                    "获取文件路径异常":"获取文件路径异常",
                    "收费重为0，不允许保存":"收费重为0，不允许保存",
                    "指定路线<":"指定路线<",
                    ">允许收货件数为<":">允许收货件数为<",
                    ">，范围外不允许收货":">，范围外不允许收货",
                    ">允许收货实重为<":">允许收货实重为<",
                    ">允许收货材重为<":">允许收货材重为<",
                    ">允许收货重量为<":">允许收货重量为<",
                    "指定路线限制货物类型<":"指定路线限制货物类型<",
                    ">，不允许收货":">，不允许收货",
                    "请输入到付金额!":"请输入到付金额!",
                    "请选择到付币别!":"请选择到付币别!",
                    "请输入付款客户!":"请输入付款客户!",
                    "请输入申报价值币别!":"请输入申报价值币别!",
                    "请选择代收币别!":"请选择代收币别!",
                    "客户管理客户的付款方式为CA不允许录入PP！":"客户管理客户的付款方式为CA不允许录入PP！",
                    "请选择费用!":"请选择费用!",
                    "请输入运费!":"请输入运费!",
                    "请录入运费!":"请录入运费!",
                    "打印完成":"打印完成",
                    "修改成功":"修改成功",
                    "补录成功":"补录成功",
                    "审单成功":"审单成功",
                    "新增成功":"新增成功",
                    "客户已停用，不能收货!":"客户已停用，不能收货!",
                    "客户已暂停，不能收货!":"客户已暂停，不能收货!",
                    "付款客户获取失败！":"付款客户获取失败！",
                    "请输入付款客户编码！":"请输入付款客户编码！",
                    "当前指定路线的计抛方式发生变化，收费重由<":"当前指定路线的计抛方式发生变化，收费重由<",
                    ">变为<":">变为<",
                    "当前指定路线的计抛方式发生变化，请重新保存单件信息":"当前指定路线的计抛方式发生变化，请重新保存单件信息",
                    "当前指定路线的材积除以数由<":"当前指定路线的材积除以数由<",
                    ">改为<":">改为<",
                    ">，请重新保存单件信息":">，请重新保存单件信息",
                    "请选择需要删除的单件信息!":"请选择需要删除的单件信息!",
                    "确认删除当前单件信息？":"确认删除当前单件信息？",
                    "提示":"提示",
                    "取消":"取消",
                    "确定删除当前所有单件信息？":"确定删除当前所有单件信息？",
                    "实重材重同时为0，不允许保存和关闭":"实重材重同时为0，不允许保存和关闭",
                    "存在为0数据,不允许保存和关闭":"存在为0数据,不允许保存和关闭",
                    "请先保存单件信息！":"请先保存单件信息！",
                    "存在为空数据,不允许保存和关闭":"存在为空数据,不允许保存和关闭",
                    "单件信息件数与运单件数不一致，是否继续保存":"单件信息件数与运单件数不一致，是否继续保存",
                    "单件取大不计抛":"单件取大不计抛",
                    "请选择指定路线!":"请选择指定路线!",
                    "录入件数为":"录入件数为",
                    "件，而单件数为":"件，而单件数为",
                    "件，是否清除多余的件数":"件，是否清除多余的件数",
                    "流水号位数不够，请重新设置":"流水号位数不够，请重新设置",
                    "子单生成规则未设置，请重新设置":"子单生成规则未设置，请重新设置",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "单号输入不规范，请重新输入！":"单号输入不规范，请重新输入！",
                    "请输入需要导入的信息!":"请输入需要导入的信息!",
                    "请输入0-9999之间的重量":"请输入0-9999之间的重量",
                    "确定删除此行吗？":"确定删除此行吗？",
                    "请先输入收件电话!":"请先输入收件电话!",
                    "请先输入收件地址!":"请先输入收件地址!",
                    "请先输入收件人!":"请先输入收件人!",
                    "保存收件人信息成功!":"保存收件人信息成功!",
                    "请先选择寄件网点!":"请先选择寄件网点!",
                    "请先选择寄件日期!":"请先选择寄件日期!",
                    "请先选择客户!":"请先选择客户!",
                    "进来了":"进来了",
                    "删除成功!":"删除成功!",
                    "请先输入寄件人!":"请先输入寄件人!",
                    "请先输入寄件人电话!":"请先输入寄件人电话!",
                    "保存寄件人信息成功!":"保存寄件人信息成功!",
                    "文件大小不能大于10MB":"文件大小不能大于10MB",
                    "不能上传jsp,bat,sh,js,exe文件":"不能上传jsp,bat,sh,js,exe文件",
                    "选填，200字符以内":"选填，200字符以内",
                },
                "fdmanifestaudit":{
                    "运单补录":"运单补录",
                    "审单":"审单",
                    "录单日期":"录单日期",
                    "录单网点":"录单网点",
                    "录单员":"录单员",
                    "客户":"客户",
                    "审单状态":"审单状态",
                    "查询":"查询",
                    "重置":"重置",
                    "水单详情":"水单详情",
                    "关闭":"关闭",
                    "查看水单":"查看水单",
                    "运单号码":"运单号码",
                    "参考编号":"参考编号",
                    "转单号码":"转单号码",
                    "寄件日期":"寄件日期",
                    "寄件网点":"寄件网点",
                    "取件员":"取件员",
                    "指定路线":"指定路线",
                    "目的地":"目的地",
                    "报关方式":"报关方式",
                    "货物类型":"货物类型",
                    "包装类型":"包装类型",
                    "件数":"件数",
                    "收费实重":"收费实重",
                    "付款方式":"付款方式",
                    "税金付款":"税金付款",
                    "收件备注":"收件备注",
                    "运单图片":"运单图片",
                    "补录人":"补录人",
                    "补录时间":"补录时间",
                    "审单人":"审单人",
                    "审单时间":"审单时间",
                    "数据来源":"数据来源",
                    "录单时间":"录单时间",
                    "请选择一行要补录的待审核数据！":"请选择一行要补录的待审核数据！",
                    "请选择一行要补录的数据！":"请选择一行要补录的数据！",
                    "审单成功":"审单成功",
                    "请至少选择一行数据！":"请至少选择一行数据！",
                    "选择的数据非【已收款】状态,不能审核":"选择的数据非【已收款】状态,不能审核",
                    "请选择需要批量审核的客户收款数据":"请选择需要批量审核的客户收款数据",
                },
            },
            "customerroutingrules":{
                "customerroutingrules":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "显示秘钥":"显示秘钥",
                    "导出":"导出",
                    "客户打单规则":"客户打单规则",
                    "所属网点":"所属网点",
                    "客户":"客户",
                    "客户名称":"客户名称",
                    "指定路线":"指定路线",
                    "走货路线":"走货路线",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "启用":"启用",
                    "允许打印转单":"允许打印转单",
                    "打单走货路线规则":"打单走货路线规则",
                    "收货时验证重量":"收货时验证重量",
                    "勾选后":"勾选后",
                    "收费重":"收费重",
                    "打单重量":"打单重量",
                    "时":"时",
                    "会自动产生问题件":"会自动产生问题件",
                    "特定代理":"特定代理",
                    "注意":"注意",
                    "保存并继续":"保存并继续",
                    "保存":"保存",
                    "关闭":"关闭",
                    "账号信息":"账号信息",
                    "格式":"格式",
                    "客户代号":"客户代号",
                    "账号":"账号",
                    "秘钥":"秘钥",
                    "复制":"复制",
                    "新增客户打单规则":"新增客户打单规则",
                    "请输入":"请输入",
                    "客户编码":"客户编码",
                    "收货验证重量":"收货验证重量",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "请至少选择一行数据":"请至少选择一行数据",
                    "客户账号:":"客户账号:",
                    "账号:":"账号:",
                    "秘钥:":"秘钥:",
                    "指定路线:":"指定路线:",
                    "请选择一行数据":"请选择一行数据",
                    "只能选择同一个客户的打单规则数据":"只能选择同一个客户的打单规则数据",
                    "打单走货路线规则必须为固定走货路线":"打单走货路线规则必须为固定走货路线",
                    "你选择的":"你选择的",
                    "条指定路线,其中":"条指定路线,其中",
                    "条开放API,是否继续?":"条开放API,是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "条已开放API,是否继续关闭?":"条已开放API,是否继续关闭?",
                    "开放API成功":"开放API成功",
                    "关闭API成功":"关闭API成功",
                    "进来了":"进来了",
                    "add/update 客户打单规则":"add/update 客户打单规则",
                    "只能选择一行数据":"只能选择一行数据",
                    "修改客户打单规则":"修改客户打单规则",
                    "请选择特定代理EDI":"请选择特定代理EDI",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "此操作将删除该客户打单规则, 是否继续?":"此操作将删除该客户打单规则, 是否继续?",
                    "请选择客户打单规则":"请选择客户打单规则",
                    "删除成功":"删除成功",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "此设置用于OMS排货前置和LABEL打印前置使用":"此设置用于OMS排货前置和LABEL打印前置使用",
                    "当打单走货路线规则 = '排货走货路线'时，由系统按排货策略选取走货路线后再打单；当打单走货路线规则 = '固定走货路线'时，可设置走货路线（表示客户对应指定路线按走货路线成本价格进行结算）":"当打单走货路线规则 = '排货走货路线'时，由系统按排货策略选取走货路线后再打单；当打单走货路线规则 = '固定走货路线'时，可设置走货路线（表示客户对应指定路线按走货路线成本价格进行结算）",
                    "此API信息用于开放给客户的对接参数":"此API信息用于开放给客户的对接参数",
                    "只适合于设置为“固定走货路线“的指定路线":"只适合于设置为“固定走货路线“的指定路线",
                }
            },
            "label":{
                "labeldesign":{
                    "确定要删除吗？":"确定要删除吗？",
                    "修改":"修改",
                    "复制":"复制",
                    "下载格式":"下载格式",
                    "打印或接口对接打印中选择此格式":"打印或接口对接打印中选择此格式",
                    "格式名称":"格式名称",
                    "最新版本号":"最新版本号",
                    "设计次数":"设计次数",
                    "删除":"删除",
                    "请选择需要上传的模版数据":"请选择需要上传的模版数据",
                    "关闭":"关闭",
                    "格式信息":"格式信息",
                    "保存":"保存",
                    "测试参数必填":"测试参数必填",
                    "LABEL类型":"LABEL类型",
                    "启用":"启用",
                    "允许客户在":"允许客户在",
                    "修改时间":"修改时间",
                    "请选择一行数据":"请选择一行数据",
                    "只支持":"只支持",
                    "创建人":"创建人",
                    "修改LABEL设计":"修改LABEL设计",
                    "测试参数":"测试参数",
                    "未设置测试参数,不能预览":"未设置测试参数,不能预览",
                    "上传格式文件":"上传格式文件",
                    "格式":"格式",
                    "新增LABEL设计":"新增LABEL设计",
                    "新增":"新增",
                    "确定":"确定",
                    "提示":"提示",
                    "格式编码":"格式编码",
                    "成功！":"成功！",
                    "注意":"注意",
                    "删除成功！":"删除成功！",
                    "客户可选":"客户可选",
                    "该格式未上传模板！":"该格式未上传模板！",
                    "预览格式":"预览格式",
                    "模版上传成功":"模版上传成功",
                    "请输入":"请输入",
                    "修改人":"修改人",
                    "取消":"取消",
                    "创建时间":"创建时间",
                    "请通过":"请通过",
                    "设计器设计好后直接上传即可":"设计器设计好后直接上传即可",
                    "修改成功！":"修改成功！",
                    "类型":"类型"
                }
            },
            "numberassignrules":{
                "numberassignrules4manifest":{
                    "新增":"新增",
                    "修改":"修改",
                    "删除":"删除",
                    "分配网点":"分配网点",
                    "分配客户":"分配客户",
                    "规则名称":"规则名称",
                    "单号类型":"单号类型",
                    "启用状态":"启用状态",
                    "查询":"查询",
                    "重置":"重置",
                    "号码段信息":"号码段信息",
                    "使用信息":"使用信息",
                    "序号":"序号",
                    "增加":"增加",
                    "作废":"作废",
                    "使用状态":"使用状态",
                    "起始单号":"起始单号",
                    "终止单号":"终止单号",
                    "总份数":"总份数",
                    "使用份数":"使用份数",
                    "作废份数":"作废份数",
                    "最新申请单号":"最新申请单号",
                    "最新申请时间":"最新申请时间",
                    "最新申请人":"最新申请人",
                    "创建时间":"创建时间",
                    "创建人":"创建人",
                    "修改时间":"修改时间",
                    "修改人":"修改人",
                    "操作":"操作",
                    "解绑":"解绑",
                    "网点":"网点",
                    "客户":"客户",
                    "指定路线":"指定路线",
                    "单号分配规则":"单号分配规则",
                    "启用":"启用",
                    "规则编码":"规则编码",
                    "校验类型":"校验类型",
                    "单号规则":"单号规则",
                    "预警份数":"预警份数",
                    "单次最大获取份数":"单次最大获取份数",
                    "单号规则说明":"单号规则说明",
                    "最多可分四段组成":"最多可分四段组成",
                    "第一":"第一",
                    "四段为固定位":"四段为固定位",
                    "第二":"第二",
                    "三段可以为流水号或校验位":"三段可以为流水号或校验位",
                    "流水号是必须项":"流水号是必须项",
                    "也只允许一项":"也只允许一项",
                    "保存":"保存",
                    "关闭":"关闭",
                    "备注":"备注",
                    "带校验位的前":"带校验位的前",
                    "个单号生成核对":"个单号生成核对",
                    "生成单号":"生成单号",
                    "由于校验类型的多样性":"由于校验类型的多样性",
                    "为确保检验类型选择正确":"为确保检验类型选择正确",
                    "凡有设置校验类型号码段":"凡有设置校验类型号码段",
                    "需统一生成单号":"需统一生成单号",
                    "确认无误后":"确认无误后",
                    "再做保存":"再做保存",
                    "请输入":"请输入",
                    "请选择":"请选择",
                    "累计总份数":"累计总份数",
                    "累计可用份数":"累计可用份数",
                    "修改单号分配规则":"修改单号分配规则",
                    "新增单号分配规则":"新增单号分配规则",
                    "请选择需要修改的数据":"请选择需要修改的数据",
                    "此操作将删除该单号分配规则, 是否继续?":"此操作将删除该单号分配规则, 是否继续?",
                    "提示":"提示",
                    "确定":"确定",
                    "取消":"取消",
                    "该单号分配规则存在号码段，不能删除":"该单号分配规则存在号码段，不能删除",
                    "请选择需要删除的数据":"请选择需要删除的数据",
                    "删除成功":"删除成功",
                    "删除异常":"删除异常",
                    "请选择单条数据进行查看":"请选择单条数据进行查看",
                    "新增号码段":"新增号码段",
                    "修改号码段":"修改号码段",
                    "只能删除‘未使用’号码段":"只能删除‘未使用’号码段",
                    "此操作将删除该号码段, 是否继续?":"此操作将删除该号码段, 是否继续?",
                    "删除号码段成功":"删除号码段成功",
                    "删除号码段异常":"删除号码段异常",
                    "只能作废‘未使用’和‘部分使用’的号码段":"只能作废‘未使用’和‘部分使用’的号码段",
                    "此操作将作废该号码段, 是否继续?":"此操作将作废该号码段, 是否继续?",
                    "作废号码段成功":"作废号码段成功",
                    "作废号码段异常":"作废号码段异常",
                    "单号规则必须含有流水号（也只允许一项）":"单号规则必须含有流水号（也只允许一项）",
                    "单号规则不能包含中文":"单号规则不能包含中文",
                    "校验类型不为空，单号规则必须含有校验位":"校验类型不为空，单号规则必须含有校验位",
                    "单号规则只能含有1个校验位":"单号规则只能含有1个校验位",
                    "校验类型为空，单号规则不能含有校验位":"校验类型为空，单号规则不能含有校验位",
                    "新增成功":"新增成功",
                    "修改成功":"修改成功",
                    "保存异常":"保存异常",
                    "起始单号、终止单号长度必须一致":"起始单号、终止单号长度必须一致",
                    "起始单号不符合单号规则（前缀不符）":"起始单号不符合单号规则（前缀不符）",
                    "终止单号不符合单号规则（前缀不符）":"终止单号不符合单号规则（前缀不符）",
                    "起始单号不符合单号规则（后缀不符）":"起始单号不符合单号规则（后缀不符）",
                    "终止单号不符合单号规则（后缀不符）":"终止单号不符合单号规则（后缀不符）",
                    "起始单号不符合单号规则（流水号或校验位不符）":"起始单号不符合单号规则（流水号或校验位不符）",
                    "终止单号不符合单号规则（流水号或校验位不符）":"终止单号不符合单号规则（流水号或校验位不符）",
                    "终止单号流水位必须大于起始单号流水位":"终止单号流水位必须大于起始单号流水位",
                    "起始单号不符合单号规则（流水号位数不符）":"起始单号不符合单号规则（流水号位数不符）",
                    "终止单号不符合单号规则（流水号位数不符）":"终止单号不符合单号规则（流水号位数不符）",
                    "新增号码段成功":"新增号码段成功",
                    "修改号码段成功":"修改号码段成功",
                }
            },
            "weightcollectionsettings":{
                "weightcollectionsettings":{
                    "波特率(bps)":"波特率(bps)",
                    "确定要删除吗？":"确定要删除吗？",
                    "修改":"修改",
                    "采集设置":"采集设置",
                    "电子称采集设置":"电子称采集设置",
                    "输出文本":"输出文本",
                    "转换正则表达式":"转换正则表达式",
                    "修改电子称":"修改电子称",
                    "查询":"查询",
                    "调整顺序超过文本值个数":"调整顺序超过文本值个数",
                    "保存":"保存",
                    "设备名称":"设备名称",
                    "新增电子秤成功":"新增电子秤成功",
                    "设备":"设备",
                    "创建人":"创建人",
                    "修改电子秤成功！":"修改电子秤成功！",
                    "组整数":"组整数",
                    "注意":"注意",
                    "删除成功！":"删除成功！",
                    "启用状态":"启用状态",
                    "设备ID":"设备ID",
                    "新增DWS成功":"新增DWS成功",
                    "录单用户":"录单用户",
                    "反转":"反转",
                    "修改DWS成功！":"修改DWS成功！",
                    "录单网点":"录单网点",
                    "波特率":"波特率",
                    "修改人":"修改人",
                    "调整顺序必须5组整数":"调整顺序必须5组整数",
                    "设备采集文本":"设备采集文本",
                    "电子秤":"电子秤",
                    "新增DWS":"新增DWS",
                    "删除":"删除",
                    "关闭":"关闭",
                    "调整顺序":"调整顺序",
                    "调整顺序必须为整数或逗号":"调整顺序必须为整数或逗号",
                    "重置":"重置",
                    "启用":"启用",
                    "修改时间":"修改时间",
                    "新增电子秤":"新增电子秤",
                    "设备类型":"设备类型",
                    "端口":"端口",
                    "必须为":"必须为",
                    "转换正则表达式不能为空":"转换正则表达式不能为空",
                    "新增":"新增",
                    "确定":"确定",
                    "新增电子称":"新增电子称",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "提示":"提示",
                    "测试":"测试",
                    "修改DWS":"修改DWS",
                    "请选择需要删除的数据":"请选择需要删除的数据",
                    "请输入":"请输入",
                    "请选择需要修改的数据":"请选择需要修改的数据",
                    "取消":"取消",
                    "创建时间":"创建时间",
                    "进入":"进入",
                    "通过正则表达式将设备采集文本转换为数据数值，并用,隔开":"通过正则表达式将设备采集文本转换为数据数值，并用,隔开",
                    "按调整顺序，将数组按一定格式（扫描单号、长、宽、高、重量，中间用,隔开）重新排列（如对应列无值时置空），输出最终格式文本":"按调整顺序，将数组按一定格式（扫描单号、长、宽、高、重量，中间用,隔开）重新排列（如对应列无值时置空），输出最终格式文本",
                    "在正式使用设备前，请做好测试，以确保输出文本的准确性":"在正式使用设备前，请做好测试，以确保输出文本的准确性",
                    "通过正则表达式将设备采集文本转换为重量":"通过正则表达式将设备采集文本转换为重量",
                }
            },


            /*调度*/
            "dispatch":{
                /*取件申请*/
                "cartask":{
                    "确定要删除吗？":"确定要删除吗？",
                    "修改":"修改",
                    "联系人":"联系人",
                    "登记人":"登记人",
                    "全部":"全部",
                    "指定路线":"指定路线",
                    "已取消":"已取消",
                    "查询":"查询",
                    "保存":"保存",
                    "联系电话":"联系电话",
                    "修改异常":"修改异常",
                    "新增取件信息":"新增取件信息",
                    "请先完善基础信息！":"请先完善基础信息！",
                    "取件公司":"取件公司",
                    "预约取件时间":"预约取件时间",
                    "请选择":"请选择",
                    "修改取件信息":"修改取件信息",
                    "删除成功！":"删除成功！",
                    "删除异常":"删除异常",
                    "重量":"重量",
                    "货物信息":"货物信息",
                    "件数":"件数",
                    "司机电话":"司机电话",
                    "修改人":"修改人",
                    "状态为‘已取件’或者‘已取消’的数据不允许修改":"状态为‘已取件’或者‘已取消’的数据不允许修改",
                    "预约取件日期":"预约取件日期",
                    "取件状态":"取件状态",
                    "已取件":"已取件",
                    "车牌号":"车牌号",
                    "修改成功！":"修改成功！",
                    "取件地址":"取件地址",
                    "注意事项":"注意事项",
                    "司机":"司机",
                    "复制数据成功":"复制数据成功",
                    "复制新增":"复制新增",
                    "请选择取件状态为’待取件‘的数据":"请选择取件状态为’待取件‘的数据",
                    "关闭":"关闭",
                    "重置":"重置",
                    "销售员":"销售员",
                    "待取件":"待取件",
                    "修改时间":"修改时间",
                    "取件申请":"取件申请",
                    "预约备注":"预约备注",
                    "请选择一行数据":"请选择一行数据",
                    "背景色设置":"背景色设置",
                    "跟单员":"跟单员",
                    "客户":"客户",
                    "相等":"相等",
                    "客户信息":"客户信息",
                    "新增":"新增",
                    "确定":"确定",
                    "登记时间":"登记时间",
                    "提示":"提示",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "每行高亮":"每行高亮",
                    "任务单号":"任务单号",
                    "添加成功！":"添加成功！",
                    "报关方式":"报关方式",
                    "导出":"导出",
                    "体积":"体积",
                    "请输入":"请输入",
                    "取消":"取消",
                    "添加异常":"添加异常"
                },
                /* 车辆管理 */
                "vehicleManagement":{
                    "确定要删除吗？":"确定要删除吗？",
                    "删除车辆异常":"删除车辆异常",
                    "修改":"修改",
                    "保存并继续":"保存并继续",
                    "保险日期":"保险日期",
                    "查询":"查询",
                    "保存":"保存",
                    "新增车辆信息":"新增车辆信息",
                    "创建人":"创建人",
                    "核定重量（KG）":"核定重量（KG）",
                    "修改异常":"修改异常",
                    "品牌":"品牌",
                    "年检日期":"年检日期",
                    "请选择":"请选择",
                    "基本信息":"基本信息",
                    "删除成功！":"删除成功！",
                    "启用状态":"启用状态",
                    "修改车辆信息":"修改车辆信息",
                    "所属网点":"所属网点",
                    "修改人":"修改人",
                    "车牌号":"车牌号",
                    "车辆管理":"车辆管理",
                    "修改成功！":"修改成功！",
                    "电话":"电话",
                    "司机":"司机",
                    "司机信息":"司机信息",
                    "备注":"备注",
                    "行驶证号":"行驶证号",
                    "删除":"删除",
                    "核定重量":"核定重量",
                    "关闭":"关闭",
                    "重置":"重置",
                    "启用":"启用",
                    "修改时间":"修改时间",
                    "请选择一行数据":"请选择一行数据",
                    "背景色设置":"背景色设置",
                    "驾驶证":"驾驶证",
                    "相等":"相等",
                    "新增":"新增",
                    "确定":"确定",
                    "最大载重":"最大载重",
                    "提示":"提示",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "体积（m³）":"体积（m³）",
                    "每行高亮":"每行高亮",
                    "最大载重（KG）":"最大载重（KG）",
                    "添加成功！":"添加成功！",
                    "车型":"车型",
                    "导出":"导出",
                    "体积":"体积",
                    "请输入":"请输入",
                    "取消":"取消",
                    "创建时间":"创建时间",
                    "添加异常":"添加异常"
                },
                /* 调度区域 */
                "carline":{
                    "确定要删除吗？":"确定要删除吗？",
                    "修改":"修改",
                    "区域名称":"区域名称",
                    "联系人":"联系人",
                    "保存并继续":"保存并继续",
                    "区域管理":"区域管理",
                    "当前车辆删除成功":"当前车辆删除成功",
                    "途径地点":"途径地点",
                    "代理":"代理",
                    "周二取件时间点":"周二取件时间点",
                    "可以输入多个":"可以输入多个",
                    "查询":"查询",
                    "保存":"保存",
                    "周一取件时间点":"周一取件时间点",
                    "联系电话":"联系电话",
                    "周六取件时间点":"周六取件时间点",
                    "周四取件时间点":"周四取件时间点",
                    "终止时间":"终止时间",
                    "创建人":"创建人",
                    "修改异常":"修改异常",
                    "结束时间":"结束时间",
                    "请先完善基础信息！":"请先完善基础信息！",
                    "操作":"操作",
                    "请选择":"请选择",
                    "基本信息":"基本信息",
                    "删除成功！":"删除成功！",
                    "启用状态":"启用状态",
                    "删除区域异常":"删除区域异常",
                    "所属网点":"所属网点",
                    "修改人":"修改人",
                    "调度区域":"调度区域",
                    "修改成功！":"修改成功！",
                    "取件地址":"取件地址",
                    "此操作将删除该车辆, 是否继续?":"此操作将删除该车辆, 是否继续?",
                    "送货地址":"送货地址",
                    "增加":"增加",
                    "备注":"备注",
                    "周五取件时间点":"周五取件时间点",
                    "删除":"删除",
                    "关闭":"关闭",
                    "修改区域信息":"修改区域信息",
                    "重置":"重置",
                    "启用":"启用",
                    "此操作将删除该代理, 是否继续?":"此操作将删除该代理, 是否继续?",
                    "修改时间":"修改时间",
                    "请选择一行数据":"请选择一行数据",
                    "背景色设置":"背景色设置",
                    "退件任务":"退件任务",
                    "起始时间":"起始时间",
                    "客户":"客户",
                    "相等":"相等",
                    "当前代理删除成功":"当前代理删除成功",
                    "新增":"新增",
                    "确定":"确定",
                    "多个之间用中文逗号分隔":"多个之间用中文逗号分隔",
                    "提示":"提示",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "每行高亮":"每行高亮",
                    "周三取件时间点":"周三取件时间点",
                    "周日取件时间点":"周日取件时间点",
                    "出货代理":"出货代理",
                    "添加成功！":"添加成功！",
                    "当前客户删除成功":"当前客户删除成功",
                    "导出":"导出",
                    "此操作将删除该客户, 是否继续?":"此操作将删除该客户, 是否继续?",
                    "请输入":"请输入",
                    "取消":"取消",
                    "创建时间":"创建时间",
                    "取件客户":"取件客户",
                    "新增区域信息":"新增区域信息",
                    "添加异常":"添加异常",
                    "区域编码":"区域编码",
                    "默认车辆":"默认车辆"
                },
                /* 调度管理 */
                "carSchedulingManagement":{
                    "确定要删除吗？":"确定要删除吗？",
                    "重新分配":"重新分配",
                    "已确认":"已确认",
                    "总重量/车辆载重":"总重量/车辆载重",
                    "调度日期":"调度日期",
                    "客户/代理":"客户/代理",
                    "修改调度信息":"修改调度信息",
                    "分配":"分配",
                    "原件信息":"原件信息",
                    "保存":"保存",
                    "调度":"调度",
                    "出货任务数":"出货任务数",
                    "拆单信息":"拆单信息",
                    "待确认任务数":"待确认任务数",
                    "已完成":"已完成",
                    "取消调度数据异常":"取消调度数据异常",
                    "拆单件数不能比原件数大":"拆单件数不能比原件数大",
                    "退件任务数":"退件任务数",
                    "请选择":"请选择",
                    "注意":"注意",
                    "异常备注":"异常备注",
                    "重新分配异常":"重新分配异常",
                    "选择调度区域":"选择调度区域",
                    "任务总数":"任务总数",
                    "件数":"件数",
                    "取件任务数":"取件任务数",
                    "取件/送货地址":"取件/送货地址",
                    "取消任务":"取消任务",
                    "车牌号":"车牌号",
                    "调度区域":"调度区域",
                    "待分配":"待分配",
                    "待调度":"待调度",
                    "注意事项":"注意事项",
                    "拆单":"拆单",
                    "司机":"司机",
                    "任务日期":"任务日期",
                    "待确认":"待确认",
                    "可直接双击表格选中的数据即可完成分配":"可直接双击表格选中的数据即可完成分配",
                    "重置":"重置",
                    "重新分配成功！":"重新分配成功！",
                    "请先完善调度信息！":"请先完善调度信息！",
                    "请选择任务状态为待确认的数据":"请选择任务状态为待确认的数据",
                    "相等":"相等",
                    "请选择待调度任务数大于0的数据":"请选择待调度任务数大于0的数据",
                    "转运任务数":"转运任务数",
                    "新任务单号":"新任务单号",
                    "提示":"提示",
                    "确":"确",
                    "分配时间":"分配时间",
                    "导出":"导出",
                    "请输入":"请输入",
                    "待调度任务数":"待调度任务数",
                    "取消":"取消",
                    "异常":"异常",
                    "区域编码":"区域编码",
                    "取消任务异常":"取消任务异常",
                    "调度数据异常":"调度数据异常",
                    "联系人":"联系人",
                    "消":"消",
                    "分配成功！":"分配成功！",
                    "输入区域编码或名称按回车键搜索":"输入区域编码或名称按回车键搜索",
                    "全部":"全部",
                    "已取消":"已取消",
                    "查询":"查询",
                    "当日调度":"当日调度",
                    "联系电话":"联系电话",
                    "定":"定",
                    "取消任务成功！":"取消任务成功！",
                    "请选择任务状态为待调度的数据":"请选择任务状态为待调度的数据",
                    "来日调度":"来日调度",
                    "重量":"重量",
                    "请选择任务状态为待分配或者待调度的数据":"请选择任务状态为待分配或者待调度的数据",
                    "司机电话":"司机电话",
                    "任务状态":"任务状态",
                    "取消调度成功！":"取消调度成功！",
                    "请选择数据并且一条":"请选择数据并且一条",
                    "总体积/车辆体积":"总体积/车辆体积",
                    "总件数":"总件数",
                    "备注":"备注",
                    "分配异常":"分配异常",
                    "小时内超时":"小时内超时",
                    "调度管理":"调度管理",
                    "关闭":"关闭",
                    "销售员":"销售员",
                    "取":"取",
                    "分配人":"分配人",
                    "数据来源":"数据来源",
                    "如果无需修改调度信息":"如果无需修改调度信息",
                    "预约备注":"预约备注",
                    "完成时间":"完成时间",
                    "请选择一行数据":"请选择一行数据",
                    "背景色设置":"背景色设置",
                    "任务类型":"任务类型",
                    "跟单员":"跟单员",
                    "请选择待确认任务数大于0的数据":"请选择待确认任务数大于0的数据",
                    "撤销调度":"撤销调度",
                    "确定":"确定",
                    "调度信息":"调度信息",
                    "确认时间":"确认时间",
                    "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                    "每行高亮":"每行高亮",
                    "调度成功！":"调度成功！",
                    "任务单号":"任务单号",
                    "分配调度区域":"分配调度区域",
                    "体积":"体积",
                    "车牌号码":"车牌号码"
                },
                /* 调度查询 */
                "cartaskquery":{
                    "联系人":"联系人",
                    "注意事项":"注意事项",
                    "总件数":"总件数",
                    "总重量/车辆载重":"总重量/车辆载重",
                    "调度日期":"调度日期",
                    "司机":"司机",
                    "客户/代理":"客户/代理",
                    "任务日期":"任务日期",
                    "备注":"备注",
                    "查询":"查询",
                    "出货任务数":"出货任务数",
                    "重置":"重置",
                    "销售员":"销售员",
                    "联系电话":"联系电话",
                    "分配人":"分配人",
                    "预约备注":"预约备注",
                    "完成时间":"完成时间",
                    "任务类型":"任务类型",
                    "跟单员":"跟单员",
                    "确认时间":"确认时间",
                    "转运任务数":"转运任务数",
                    "退件任务数":"退件任务数",
                    "异常任务数":"异常任务数",
                    "异常备注":"异常备注",
                    "任务单号":"任务单号",
                    "重量":"重量",
                    "分配时间":"分配时间",
                    "任务总数":"任务总数",
                    "件数":"件数",
                    "明细":"明细",
                    "取件任务数":"取件任务数",
                    "体积":"体积",
                    "司机电话":"司机电话",
                    "车牌号码":"车牌号码",
                    "取件/送货地址":"取件/送货地址",
                    "车牌号":"车牌号",
                    "任务状态":"任务状态",
                    "调度区域":"调度区域",
                    "总体积/车辆体积":"总体积/车辆体积"
                }

            },


        },
    },
    "components":{
        "problemsRegistration":{
            "index":{
                "只能上传jpg/png/word/excel/pdf文件":"只能上传jpg/png/word/excel/pdf文件",
                "点击上传附件":"点击上传附件",
                "问题状态":"问题状态",
                "登记成功！":"登记成功！",
                "运单号码":"运单号码",
                "关闭":"关闭",
                "可上传一个后缀名为":"可上传一个后缀名为",
                "可多选":"可多选",
                "问题描述":"问题描述",
                "登记":"登记",
                "指定处理人":"指定处理人",
                "附件":"附件",
                "确定":"确定",
                "文件大小不能大于15MB":"文件大小不能大于15MB",
                "通知人":"通知人",
                "内容有修改,是否确认关闭？":"内容有修改,是否确认关闭？",
                "提示":"提示",
                "大小不能超过":"大小不能超过",
                "处理时限":"处理时限",
                "问题件信息":"问题件信息",
                "处理网点":"处理网点",
                "请输入":"请输入",
                "获取运单信息失败！":"获取运单信息失败！",
                "登记异常":"登记异常",
                "获取问题状态信息失败！":"获取问题状态信息失败！",
                "取消":"取消",
                "的附件":"的附件"
            }
        }
    }
};
export default zhCN;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/zh-CN.js